/* ภาษาไทย — Thai */
const th = {
  nav: {
    home: 'หน้าแรก',
    imageConverter: 'แปลงรูปภาพ',
    imageCompressor: 'บีบอัดรูปภาพ',
    otherTools: 'เครื่องมืออื่นๆ',
    resizeImage: 'ปรับขนาดรูปภาพ',
    cropImage: 'ครอปรูปภาพ',
    photoEditor: 'แก้ไขรูปภาพ',
    removeBackground: 'ลบพื้นหลัง',
    watermarkImage: 'ใส่ลายน้ำ',
    qrCodeGenerator: 'สร้าง QR Code',
    qrCodeScanner: 'สแกน QR Code',
    aboutUs: 'เกี่ยวกับเรา',
    faceBlur: 'เบลอใบหน้า',
  },

  hero: {
    heading: 'เครื่องมือรูปภาพทุกอย่างที่คุณต้องการ',
    subheading: 'เครื่องมือออนไลน์ฟรีสำหรับแปลง บีบอัด ปรับขนาด ครอป และแก้ไขรูปภาพ ประมวลผลในเบราว์เซอร์ — รวดเร็วและปลอดภัย',
  },

  tools: {
    compressImage: { title: 'บีบอัดรูปภาพ', desc: 'บีบอัด JPG, PNG, SVG และ GIF โดยรักษาคุณภาพ' },
    resizeImage: { title: 'ปรับขนาดรูปภาพ', desc: 'ปรับขนาดเป็นเปอร์เซ็นต์หรือพิกเซล' },
    cropImage: { title: 'ครอปรูปภาพ', desc: 'ครอป JPG, PNG และ GIF ได้อย่างง่ายดาย' },
    convertToJpg: { title: 'แปลงเป็น JPG', desc: 'แปลง PNG, GIF, TIF, SVG, WEBP และอื่นๆ เป็น JPG' },
    convertFromJpg: { title: 'แปลงจาก JPG', desc: 'แปลงรูปภาพ JPG เป็น PNG และ GIF' },
    qrCodeGenerator: { title: 'สร้าง QR Code', desc: 'สร้าง QR Code แบบกำหนดเองสำหรับ URL, ข้อความ, WiFi, ผู้ติดต่อ และอื่นๆ' },
    qrCodeScanner: { title: 'สแกน QR Code', desc: 'สแกน QR Code ทันทีด้วยกล้องหรืออัปโหลดรูปภาพ' },
    blurFace: { title: 'เบลอใบหน้า', desc: 'ตรวจจับและเบลอใบหน้าอัตโนมัติเพื่อปกป้องความเป็นส่วนตัว' },
    removeBackground: { title: 'ลบพื้นหลัง', desc: 'ลบพื้นหลังรูปภาพได้อย่างรวดเร็วและแม่นยำ' },
    watermarkImage: { title: 'ใส่ลายน้ำ', desc: 'ใส่ลายน้ำบนรูปภาพได้ในไม่กี่วินาที' },
  },

  whyChoose: {
    label: 'ทำไมต้องเราใช้',
    heading: 'วิธีที่ชาญฉลาดกว่าในการแก้ไขรูปภาพ',
    subheading: 'ได้รับความไว้วางใจจากผู้สร้าง นักออกแบบ และนักพัฒนาหลายพันคนทั่วโลก',
    reasons: {
      fast: { title: 'เร็วมาก', desc: 'ประมวลผลทั้งหมดในเบราว์เซอร์ ไม่ต้องอัปโหลดไปยังเซิร์ฟเวอร์ภายนอก' },
      private: { title: '100% ปลอดภัยและเป็นส่วนตัว', desc: 'ไฟล์ของคุณไม่เคยออกจากอุปกรณ์ เราไม่จัดเก็บหรือแบ่งปันรูปภาพของคุณ' },
      noLimits: { title: 'ไม่มีขีดจำกัด ไม่ต้องลงทะเบียน', desc: 'ใช้เครื่องมือทั้งหมดได้เท่าที่ต้องการ — ฟรีทั้งหมด' },
      quality: { title: 'คุณภาพระดับมืออาชีพ', desc: 'อัลกอริทึมของเราให้ผลลัพธ์ระดับมืออาชีพ' },
      batch: { title: 'ประมวลผลแบบกลุ่ม', desc: 'ประมวลผลหลายไฟล์พร้อมกัน' },
      everywhere: { title: 'ใช้งานได้ทุกที่', desc: 'ทำงานได้อย่างสมบูรณ์บนเดสก์ท็อป แท็บเล็ต และโทรศัพท์' },
    },
    stats: {
      imagesProcessed: 'รูปภาพที่ประมวลผลแล้ว',
      countriesServed: 'ประเทศที่ให้บริการ',
      uptime: 'เวลาทำงาน',
      freeTools: 'เครื่องมือฟรี',
    },
  },

  footer: {
    tagline: 'เครื่องมือรูปภาพออนไลน์ฟรี — แปลง บีบอัด ปรับขนาด ครอป และแก้ไขรูปภาพในไม่กี่วินาที',
    imageTools: 'เครื่องมือรูปภาพ',
    moreTools: 'เครื่องมือเพิ่มเติม',
    company: 'บริษัท',
    contact: 'ติดต่อ',
    allRightsReserved: 'สงวนลิขสิทธิ์ทั้งหมด',
    privacyPolicy: 'นโยบายความเป็นส่วนตัว',
    termsOfService: 'ข้อกำหนดการใช้งาน',
  },

  faq: {
    badge: 'คำถามที่พบบ่อย',
    heading: 'คำถามที่พบบ่อย',
    subheading: 'คำตอบด่วนสำหรับคำถามทั่วไปเกี่ยวกับเครื่องมือเหล่านี้',
    stillHaveQuestions: 'ยังมีคำถามอยู่? เรายินดีช่วยเหลือ!',
    reachOut: 'ติดต่อเรา',
    questionHeader: 'คำถาม',
  },

  contactForm: {
    badge: 'ติดต่อเรา',
    title: 'ติดต่อเรา',
    subtitle: 'เรายินดีที่ได้ยินจากคุณ ส่งข้อความถึงเราได้เลย!',
    nameLabel: 'ชื่อ',
    namePlaceholder: 'ชื่อ-นามสกุลของคุณ',
    emailLabel: 'อีเมล',
    emailPlaceholder: 'you@email.com',
    subjectLabel: 'หัวข้อ',
    subjectPlaceholder: 'เรื่องนี้เกี่ยวกับอะไร?',
    messageLabel: 'ข้อความ',
    messagePlaceholder: 'เขียนข้อความของคุณที่นี่…',
    errName: 'จำเป็นต้องกรอกชื่อ',
    errEmail: 'จำเป็นต้องกรอกอีเมล',
    errEmailInvalid: 'กรอกอีเมลที่ถูกต้อง',
    errSubject: 'จำเป็นต้องกรอกหัวข้อ',
    errMessage: 'จำเป็นต้องกรอกข้อความ',
    sending: 'กำลังส่ง…',
    send: 'ส่งข้อความ',
    successTitle: 'ส่งข้อความแล้ว!',
    successMsg: 'ขอบคุณที่ติดต่อเรา เราจะตอบกลับในไม่ช้า',
    sendAnother: 'ส่งอีกครั้ง',
    sendError: 'เกิดข้อผิดพลาด โปรดลองใหม่',
  },

  about: {
    label: 'เกี่ยวกับเรา',
    heading: 'สร้างสำหรับผู้สร้าง โดยผู้สร้าง',
    subheading: 'เราเชื่อว่าเครื่องมือรูปภาพที่ทรงพลังควรฟรี รวดเร็ว และเข้าถึงได้สำหรับทุกคน',
    missionTitle: 'พันธกิจของเรา',
    missionText: 'photremium.com สร้างขึ้นด้วยเป้าหมายเดียว: มอบประสบการณ์การแก้ไขรูปภาพที่ใช้งานง่าย รวดเร็ว และเป็นส่วนตัวที่สุดบนเว็บ',
    privacyTitle: 'ความเป็นส่วนตัวเป็นอันดับแรก',
    privacyText: 'เราไม่อัปโหลด จัดเก็บ หรือประมวลผลรูปภาพของคุณจากระยะไกล ทุกอย่างอยู่บนอุปกรณ์ของคุณ',
    techTitle: 'เทคโนโลยีทันสมัย',
    techText: 'สร้างด้วยเทคโนโลยีเว็บล่าสุด รวมถึง WebAssembly, Canvas API และ React สมัยใหม่',
    communityTitle: 'เน้นชุมชน',
    communityText: 'ทุกฟีเจอร์ได้รับแรงบันดาลใจจากความคิดเห็นของผู้ใช้จริง',
    globalTitle: 'การเข้าถึงระดับโลก',
    globalText: 'ใช้งานโดยผู้สร้างจากกว่า 120 ประเทศ',
  },

  seo: {
    homeTitle: 'photremium.com — เครื่องมือแปลง บีบอัด และแก้ไขรูปภาพออนไลน์ฟรี',
    homeDesc: 'แปลง บีบอัด ปรับขนาด ครอป และแก้ไขรูปภาพฟรีออนไลน์',
    homeKeywords: 'แปลงรูปภาพ, บีบอัดรูปภาพ, ปรับขนาดรูปภาพ, ครอปรูปภาพ, แก้ไขรูปภาพ',
    aboutTitle: 'เกี่ยวกับ photremium.com — พันธกิจของเรา',
    aboutDesc: 'เรียนรู้เกี่ยวกับ photremium.com เครื่องมือรูปภาพออนไลน์ฟรีที่ผู้คนนับล้านไว้วางใจ',
    aboutKeywords: 'เกี่ยวกับ photremium.com, เครื่องมือรูปภาพ, แก้ไขรูปภาพฟรี',
  },

      privacyPolicyPage: {
    seo: {
      title: 'นโยบายความเป็นส่วนตัว — โฟเทรเมียม | ไม่มีการอัพโหลดเซิร์ฟเวอร์ ไม่มีพื้นที่จัดเก็บข้อมูล',
      description: 'นโยบายความเป็นส่วนตัวของ Photremium อธิบายถึงวิธีที่เราปกป้องความเป็นส่วนตัวของคุณ การประมวลผลภาพทั้งหมดเกิดขึ้นในเบราว์เซอร์ของคุณ 100% — ไม่มีการอัปโหลดไฟล์ไปยังเซิร์ฟเวอร์ใดๆ ไม่มีการรวบรวมข้อมูลส่วนบุคคล ไม่มีการติดตาม',
      ogTitle: 'นโยบายความเป็นส่วนตัว — โฟเทรเมียม | ไม่มีการอัปโหลด พื้นที่เก็บข้อมูลเป็นศูนย์',
      ogDescription: 'ไฟล์ของคุณยังคงอยู่ในอุปกรณ์ของคุณ Photremium ประมวลผลภาพทั้งหมดภายในเบราว์เซอร์ของคุณ โดยไม่มีการติดต่อกับเซิร์ฟเวอร์ ไม่มีข้อมูลที่เก็บไว้ และไม่มีการติดตาม',
      twitterTitle: 'นโยบายความเป็นส่วนตัว — โฟเทรเมียม',
      twitterDescription: 'เครื่องมือรูปภาพบนเบราว์เซอร์ 100% ไม่มีการอัปโหลด ไม่มีพื้นที่เก็บข้อมูล ไม่มีการติดตาม อ่านนโยบายความเป็นส่วนตัวฉบับเต็มของเรา',
      schemaName: 'นโยบายความเป็นส่วนตัว - Photremium',
      schemaDescription: 'นโยบายความเป็นส่วนตัวของ Photremium - ไม่มีการอัพโหลดเซิร์ฟเวอร์ ไม่มีข้อมูล การประมวลผลภาพในเบราว์เซอร์ 100%'
    },
    hero: {
      badge: 'นโยบายความเป็นส่วนตัว',
      titlePrefix: 'ความเป็นส่วนตัวของคุณคือของเรา',
      titleHighlight: 'ลำดับความสำคัญสูงสุด',
      subPrefix: 'photremium.com สร้างขึ้นบนหลักการง่ายๆ —',
      subStrong: 'ไฟล์ของคุณจะไม่ออกจากอุปกรณ์ของคุณ',
      subSuffix: 'เครื่องมือรูปภาพทุกอันบนไซต์นี้ทำงานภายในเบราว์เซอร์ของคุณทั้งหมด ไม่มีการอัปโหลด ไม่มีเมฆ. ไม่มีการประนีประนอม',
      effectiveLabel: 'มีประสิทธิภาพ',
      lastUpdatedLabel: 'อัปเดตล่าสุด',
      worldwideLabel: 'ใช้ทั่วโลก'
    },
    trustCards: [
      {
        title: 'ไม่มีการอัพโหลดเซิร์ฟเวอร์',
        desc: 'ไฟล์ของคุณจะไม่ออกจากอุปกรณ์ของคุณ การประมวลผลทั้งหมดอยู่ในเบราว์เซอร์ 100%'
      },
      {
        title: 'การจัดเก็บข้อมูลเป็นศูนย์',
        desc: 'เราไม่ได้เก็บอะไรเกี่ยวกับคุณ รูปภาพของคุณ หรือกิจกรรมของคุณ'
      },
      {
        title: 'ไม่มีการติดตาม',
        desc: 'ไม่มีการติดตามพฤติกรรม ไม่มีลายนิ้วมือ ไม่มีโปรไฟล์'
      },
      {
        title: 'เป็นมิตรกับ GDPR',
        desc: 'ได้รับการออกแบบตั้งแต่ต้นจนจบเพื่อให้เคารพกฎระเบียบด้านความเป็นส่วนตัวทั่วโลก'
      }
    ],
    contentsTitle: 'สารบัญ',
    toc: {
      overview: 'ภาพรวม',
      'no-upload': 'ไม่มีการประมวลผลเซิร์ฟเวอร์',
      'data-collect': 'ข้อมูลที่เรารวบรวม',
      cookies: 'คุกกี้และการจัดเก็บ',
      'third-party': 'บริการของบุคคลที่สาม',
      analytics: 'การวิเคราะห์',
      children: 'ความเป็นส่วนตัวของเด็ก',
      rights: 'สิทธิของคุณ',
      security: 'ความปลอดภัย',
      changes: 'การเปลี่ยนแปลงนโยบาย',
      contact: 'ติดต่อเรา'
    },
    sections: {
      overview: {
        title: '1. ภาพรวม',
        subtitle: 'นโยบายนี้ครอบคลุมถึงอะไรบ้าง',
        p1Prefix: 'นโยบายความเป็นส่วนตัวนี้อธิบายถึงวิธีการ',
        p1Middle: '("เรา", "พวกเรา" หรือ "ของเรา") จัดการ - หรือแม่นยำกว่านั้น',
        p1Italic: 'ไม่จัดการ',
        p1Suffix: 'ข้อมูลส่วนบุคคลของคุณเมื่อคุณใช้เครื่องมือรูปภาพออนไลน์ฟรีของเราที่',
        p2: 'ต่างจากเว็บแอปพลิเคชันทั่วไปที่ส่งไฟล์ไปยังเซิร์ฟเวอร์ระยะไกลเพื่อการประมวลผล photremium.com ใช้ API ของเบราว์เซอร์สมัยใหม่ (Canvas API, WebAssembly, WebWorkers) เพื่อดำเนินการทุกอย่างในเครื่องบนอุปกรณ์ของคุณ ผลลัพธ์: ไม่มีการส่งข้อมูล ไม่มีการจัดเก็บข้อมูล และไม่มีความเสี่ยง',
        calloutLabel: 'สรุปภาษาอังกฤษธรรมดา:',
        calloutText: 'เราไม่สามารถเห็นภาพของคุณ เราไม่ต้องการ และเทคโนโลยีของเราได้รับการออกแบบมาเป็นพิเศษจนเราไม่สามารถมองเห็นได้'
      },
      noUpload: {
        title: '2. ไม่มีการประมวลผลเซิร์ฟเวอร์ — ไม่เคย',
        subtitle: 'เครื่องมือของเราทำงานอย่างไร',
        introPrefix: 'ทุกเครื่องมือบน photremium.com — เครื่องมือแปลงรูปภาพ, คอมเพรสเซอร์, ตัวปรับขนาด, เครื่องมือลบพื้นหลัง, การเบลอใบหน้า, ลายน้ำ, ครอบตัด และเครื่องมือโค้ด QR — ประมวลผลไฟล์ของคุณ',
        introStrong: '100% ภายในเว็บเบราว์เซอร์ของคุณ',
        introSuffix: 'ใช้ JavaScript ฝั่งไคลเอ็นต์และ WebAssembly',
        points: [
          {
            label: 'ไม่มีการอัปโหลดไฟล์เกิดขึ้น',
            text: 'เมื่อคุณเลือกไฟล์ ไฟล์นั้นจะถูกอ่านโดย File API ของเบราว์เซอร์ของคุณและประมวลผลในหน่วยความจำ โดยจะไม่ส่งผ่านเครือข่าย'
          },
          {
            label: 'ไม่มีเซิร์ฟเวอร์ใดรับภาพของคุณ',
            text: 'CDN ของเราให้บริการเฉพาะเนื้อหา HTML, CSS และ JavaScript ที่จำเป็นในการเรียกใช้แอป ไม่ใช่ไฟล์ของคุณ'
          },
          {
            label: 'ไม่มีการจัดเก็บชั่วคราว',
            text: 'ผลลัพธ์ที่ประมวลผลจะมีอยู่ในหน่วยความจำเบราว์เซอร์ของคุณเท่านั้น และจะถูกเผยแพร่เมื่อคุณปิดหรือออกจากเพจ'
          },
          {
            label: 'ทำงานแบบออฟไลน์',
            text: 'เครื่องมือส่วนใหญ่ยังคงทำงานต่อไปได้โดยไม่ต้องเชื่อมต่ออินเทอร์เน็ตหลังจากโหลดหน้าแรก — เป็นข้อพิสูจน์เพิ่มเติมว่าไม่มีเซิร์ฟเวอร์เกี่ยวข้อง'
          }
        ],
        callout: 'คุณสามารถตรวจสอบได้ด้วยตัวเอง: เปิดแท็บเครือข่ายของเบราว์เซอร์ในเครื่องมือสำหรับนักพัฒนา เลือกรูปภาพ และยืนยันว่าไม่มีการส่งข้อมูลไฟล์ไปยังเซิร์ฟเวอร์ภายนอกใดๆ'
      },
      dataCollect: {
        title: '3. ข้อมูลที่เรารวบรวม (และไม่รวบรวม)',
        subtitle: 'ความโปร่งใสอย่างสมบูรณ์เกี่ยวกับแนวทางปฏิบัติด้านข้อมูล',
        headers: {
          type: 'ประเภทข้อมูล',
          collected: 'รวบรวม?',
          whereWhy: 'ที่ไหน/ทำไม'
        },
        rows: [
          {
            type: 'รูปภาพ/ไฟล์ของคุณ',
            badge: 'ไม่เคย',
            variant: 'สีเขียว',
            showX: true,
            whereWhy: 'ประมวลผลทั้งหมดในเบราว์เซอร์ของคุณ — ไม่เคยส่ง'
          },
          {
            type: 'ชื่อ / ที่อยู่อีเมล',
            badge: 'ไม่เคย',
            variant: 'สีเขียว',
            showX: true,
            whereWhy: 'ไม่จำเป็นต้องมีบัญชีหรือลงทะเบียนเพื่อใช้เครื่องมือใด ๆ'
          },
          {
            type: 'ที่อยู่ IP',
            badge: 'น้อยที่สุด',
            variant: 'สีเทา',
            showX: false,
            whereWhy: 'บันทึกเว็บเซิร์ฟเวอร์มาตรฐานจะเก็บไว้ <= 30 วัน ไม่เชื่อมโยงกับข้อมูลระบุตัวตน'
          },
          {
            type: 'เบราว์เซอร์ / ประเภทระบบปฏิบัติการ',
            badge: 'น้อยที่สุด',
            variant: 'สีเทา',
            showX: false,
            whereWhy: 'ส่งโดยเบราว์เซอร์ของคุณโดยอัตโนมัติ ใช้สำหรับความเข้ากันได้เท่านั้น'
          },
          {
            type: 'หน้าที่เข้าชม / คลิก',
            badge: 'แบบรวมกลุ่ม',
            variant: 'สีฟ้า',
            showX: false,
            whereWhy: 'การวิเคราะห์แบบไม่เปิดเผยตัวตนเท่านั้น (ไม่มีการระบุตัวตนส่วนบุคคล)'
          },
          {
            type: 'การตั้งค่าภาษา',
            badge: 'เฉพาะท้องถิ่นเท่านั้น',
            variant: 'สีฟ้า',
            showX: false,
            whereWhy: 'บันทึกลงใน localStorage บนอุปกรณ์ของคุณ — ไม่เคยส่งถึงเรา'
          },
          {
            type: 'ข้อมูลการชำระเงิน/การเงิน',
            badge: 'ไม่เคย',
            variant: 'สีเขียว',
            showX: true,
            whereWhy: 'photoremium.com เป็นบริการฟรีโดยไม่จำเป็นต้องชำระเงิน'
          }
        ]
      },
      cookies: {
        title: '4. คุกกี้และการจัดเก็บในตัวเครื่อง',
        subtitle: 'สิ่งที่ถูกจัดเก็บไว้ในอุปกรณ์ของคุณ',
        intro: 'photremium.com ไม่ใช้คุกกี้โฆษณา ไม่มีคุกกี้การติดตามข้ามไซต์ และไม่มีคุกกี้ของบุคคลที่สาม พื้นที่เก็บข้อมูลเบราว์เซอร์เดียวที่เราใช้คือสำหรับฟังก์ชันการทำงานที่จำเป็นของไซต์',
        points: [
          {
            label: 'การตั้งค่าภาษา',
            text: 'เก็บไว้ใน localStorage เพื่อให้ไซต์จดจำภาษาที่คุณต้องการระหว่างการเข้าชม ไม่เคยส่งไปยังเซิร์ฟเวอร์ของเรา'
          },
          {
            label: 'การตั้งค่าธีม / UI',
            text: 'หากคุณตั้งค่าการแสดงผล ค่าดังกล่าวจะถูกบันทึกไว้ในอุปกรณ์ของคุณเท่านั้น'
          },
          {
            label: 'ไม่มีคุกกี้เซสชั่น',
            text: 'photremium.com ไม่มีระบบการเข้าสู่ระบบ ดังนั้นจึงไม่มีการเขียนคุกกี้ ID เซสชัน'
          }
        ],
        callout: 'คุณสามารถล้างที่เก็บข้อมูลในเครื่องของ photremium.com ทั้งหมดได้ตลอดเวลาผ่านการตั้งค่าเบราว์เซอร์ของคุณ (การตั้งค่า -> ความเป็นส่วนตัว -> ล้างข้อมูลการท่องเว็บ -> ข้อมูลแคชและคุกกี้) การทำเช่นนี้จะไม่ส่งผลต่อความสามารถในการใช้เครื่องมือของคุณ'
      },
      thirdParty: {
        title: '5. บริการของบุคคลที่สาม',
        subtitle: 'บริการภายนอกที่เราใช้และเหตุผล',
        intro: 'photremium.com ใช้ชุดบริการของบุคคลที่สามที่เชื่อถือได้เพียงเล็กน้อยสำหรับโครงสร้างพื้นฐานและประสิทธิภาพเท่านั้น บริการเหล่านี้ไม่ได้รับภาพหรือข้อมูลส่วนบุคคลใด ๆ ของคุณ',
        headers: {
          service: 'บริการ',
          purpose: 'วัตถุประสงค์',
          dataShared: 'ข้อมูลที่ใช้ร่วมกัน',
          privacyPolicy: 'นโยบายความเป็นส่วนตัว'
        },
        rows: [
          {
            service: 'เพจคลาวด์แฟลร์',
            purpose: 'โฮสติ้งและการส่งมอบสินทรัพย์ไซต์ CDN',
            dataShared: 'ที่อยู่ IP, ส่วนหัว HTTP (มาตรฐาน)',
            privacyLink: 'https://www.cloudflare.com/privacypolicy/',
            privacyText: 'cloudflare.com/privacypolicy'
          },
          {
            service: 'แบบอักษรที่ยอดเยี่ยม',
            purpose: 'แบบอักษรของไอคอนโหลดจาก CDN',
            dataShared: 'ที่อยู่ IP (คำขอ CSS เท่านั้น)',
            privacyLink: 'https://fontawesome.com/privacy',
            privacyText: 'fontawesome.com/privacy'
          },
          {
            service: 'Google แบบอักษร',
            purpose: 'การโหลดแบบอักษร (ถ้ามี)',
            dataShared: 'ที่อยู่ IP (คำขอแบบอักษรเท่านั้น)',
            privacyLink: 'https://policies.google.com/privacy',
            privacyText: 'policies.google.com'
          }
        ],
        outro: 'เราไม่แบ่งปันข้อมูลของคุณกับผู้ลงโฆษณา นายหน้าข้อมูล หรือบุคคลที่สามอื่นใดนอกเหนือจากผู้ให้บริการโครงสร้างพื้นฐานที่ระบุไว้ข้างต้น'
      },
      analytics: {
        title: '6. การวิเคราะห์',
        subtitle: 'รวบรวมข้อมูลการใช้งานที่เคารพความเป็นส่วนตัว',
        introPrefix: 'เพื่อทำความเข้าใจว่าเครื่องมือใดได้รับความนิยมและจะปรับปรุงเว็บไซต์อย่างไร เราอาจรวบรวม',
        introStrong: 'โดยรวมไม่ระบุชื่อ',
        introSuffix: 'สถิติการใช้งาน เช่น:',
        points: [
          'จำนวนการดูหน้าเว็บต่อเครื่องมือ (ไม่มีการระบุตัวตนผู้ใช้)',
          'แหล่งอ้างอิง (เช่น การค้นหาโดย Google, ลิงก์โดยตรง) — ไม่มีข้อมูลส่วนบุคคล',
          'ข้อมูลทางภูมิศาสตร์ระดับประเทศ (ไม่ใช่เมืองหรือตำแหน่งที่แน่นอน)',
          'เบราว์เซอร์ / ประเภทอุปกรณ์สำหรับการวิเคราะห์ความเข้ากันได้'
        ],
        calloutLabel: 'ไม่มีข้อมูลเชื่อมโยงกับคุณเป็นการส่วนตัว',
        calloutText: 'เราไม่ได้ใช้ Google Analytics หรือ Meta Pixel การวิเคราะห์ใดๆ ที่เราใช้เป็นเครื่องมือที่ให้ความสำคัญกับความเป็นส่วนตัวเป็นอันดับแรก (เช่น เป็นไปได้หรือคล้ายกัน)'
      },
      children: {
        title: '7. ความเป็นส่วนตัวของเด็ก',
        subtitle: 'การปฏิบัติตาม COPPA และความปลอดภัยของเด็ก',
        p1: 'photremium.com จะไม่รวบรวมข้อมูลส่วนบุคคลใด ๆ จากเด็กอายุต่ำกว่า 13 ปี (หรือ 16 ปีในสหภาพยุโรปภายใต้ GDPR) โดยเจตนา เนื่องจากเราไม่ได้รวบรวมข้อมูลส่วนบุคคลจากผู้ใช้รายใด จึงไม่มีอะไรพิเศษที่ต้องทำสำหรับผู้ใช้ที่อายุน้อยกว่า — ไซต์นี้มีความปลอดภัยเท่าเทียมกันสำหรับทุกคน',
        p2Prefix: 'หากคุณเชื่อว่าเด็กได้ส่งข้อมูลส่วนบุคคลผ่านแบบฟอร์มการติดต่อของเรา โปรดติดต่อเราทันทีที่',
        p2Suffix: 'และเราจะลบมันทันที'
      },
      rights: {
        title: '8. สิทธิ์ของคุณ',
        subtitle: 'GDPR, CCPA และสิทธิ์ความเป็นส่วนตัวทั่วโลก',
        intro: 'เนื่องจาก photremium.com ไม่ได้รวบรวมข้อมูลที่สามารถระบุตัวบุคคลได้ สิทธิ์ของเจ้าของข้อมูลส่วนใหญ่จึงมีผลเพียงเล็กน้อย — ไม่มีข้อมูลเกี่ยวกับคุณที่จะเข้าถึง แก้ไข หรือลบได้ อย่างไรก็ตาม เรารับทราบและเคารพในสิทธิดังต่อไปนี้อย่างเต็มที่:',
        points: [
          {
            label: 'สิทธิในการเข้าถึง',
            text: 'คุณสามารถขอสำเนาข้อมูลใด ๆ เกี่ยวกับคุณที่เราเก็บไว้ได้ (ไม่มีสิ่งใดนอกจากบันทึกที่ไม่ระบุชื่อ)'
          },
          {
            label: 'สิทธิในการแก้ไข',
            text: 'คุณสามารถขอแก้ไขข้อมูลส่วนบุคคลที่ไม่ถูกต้องได้'
          },
          {
            label: 'สิทธิในการลบล้าง ("สิทธิที่จะถูกลืม")',
            text: 'คุณสามารถขอให้ลบข้อมูลส่วนบุคคลใด ๆ ที่เราถือครองได้ (GDPR Art. 17, CCPA)'
          },
          {
            label: 'สิทธิ์ในการคัดค้าน / ยกเลิก',
            text: 'คุณสามารถเลือกไม่รับคอลเลกชันการวิเคราะห์ใดๆ ในอนาคตได้โดยใช้เครื่องมือเลือกไม่รับหรือบล็อกโฆษณาระดับเบราว์เซอร์'
          },
          {
            label: 'สิทธิ์ในการพกพาข้อมูล',
            text: 'งานทั้งหมดของคุณจะถูกดาวน์โหลดไปยังอุปกรณ์ของคุณโดยตรง โดยไม่ต้องร้องขอการส่งออก'
          }
        ],
        callout: 'สิทธิ์เหล่านี้ใช้กับผู้ใช้ทุกคนทั่วโลกโดยไม่คำนึงถึงเขตอำนาจศาล - เราใช้มาตรฐานสูงสุด (GDPR) เป็นพื้นฐานของเรา'
      },
      security: {
        title: '9. ความปลอดภัย',
        subtitle: 'เราปกป้องประสบการณ์ของคุณอย่างไร',
        intro: 'ข้อมูลที่ปลอดภัยที่สุดคือข้อมูลที่ไม่เคยถูกรวบรวม สถาปัตยกรรมฝั่งไคลเอ็นต์ของ photremium.com หมายความว่าการละเมิดเซิร์ฟเวอร์ไม่สามารถเปิดเผยไฟล์ของคุณได้ เนื่องจากไฟล์ของคุณไม่เคยอยู่บนเซิร์ฟเวอร์ของเรา มาตรการรักษาความปลอดภัยเพิ่มเติม ได้แก่ :',
        points: [
          {
            label: 'การบังคับใช้ HTTPS',
            text: 'การรับส่งข้อมูลทั้งหมดระหว่างเบราว์เซอร์ของคุณและ CDN ของเราได้รับการเข้ารหัสผ่าน TLS 1.2+ พร้อม HSTS'
          },
          {
            label: 'นโยบายการรักษาความปลอดภัยของเนื้อหา (CSP)',
            text: 'ส่วนหัวที่เข้มงวดป้องกันการเขียนสคริปต์ข้ามไซต์และการแทรกสคริปต์แบบอินไลน์'
          },
          {
            label: 'การตรวจสอบการพึ่งพาปกติ',
            text: 'เราตรวจสอบและอัปเดตแพ็คเกจ npm เป็นประจำเพื่อแก้ไขช่องโหว่ที่ทราบ'
          }
        ],
        disclosurePrefix: 'การเปิดเผยอย่างมีความรับผิดชอบ',
        disclosureTextPrefix: 'พบปัญหาด้านความปลอดภัย? ส่งอีเมลถึงเราที่',
        disclosureTextSuffix: 'และเราจะตอบกลับภายใน 48 ชั่วโมง'
      },
      changes: {
        title: '10. การเปลี่ยนแปลงนโยบายนี้',
        subtitle: 'วิธีที่เราจัดการการอัปเดตนโยบาย',
        intro: 'เราอาจอัปเดตนโยบายความเป็นส่วนตัวนี้เป็นครั้งคราวเพื่อสะท้อนถึงการเปลี่ยนแปลงแนวทางปฏิบัติ เครื่องมือ หรือข้อกำหนดทางกฎหมายของเรา เมื่อเราทำ:',
        points: [
          {
            label: '"อัปเดตล่าสุด"',
            text: 'วันที่ที่ด้านบนของหน้านี้จะถูกแก้ไข'
          },
          {
            label: 'การเปลี่ยนแปลงวัสดุ',
            text: 'จะมีการสื่อสารผ่านประกาศที่เด่นชัดบนหน้าแรกเป็นเวลาอย่างน้อย 30 วัน'
          },
          {
            label: 'รุ่นก่อนหน้า',
            text: 'ของนโยบายนี้จะถูกเก็บถาวรและพร้อมใช้งานเมื่อมีการร้องขอ'
          }
        ],
        outro: 'การใช้ photremium.com ต่อไปหลังจากเผยแพร่การเปลี่ยนแปลงแล้ว ถือว่ายอมรับนโยบายที่อัปเดต เราขอแนะนำให้คุณตรวจสอบหน้านี้เป็นระยะ'
      },
      contact: {
        title: '11. การติดต่อและการร้องขอข้อมูล',
        subtitle: 'ติดต่อเกี่ยวกับความเป็นส่วนตัว',
        p1Prefix: 'หากมีคำถาม ข้อกังวล หรือการร้องขอข้อมูลที่เป็นทางการที่เกี่ยวข้องกับนโยบายความเป็นส่วนตัวนี้ โปรดติดต่อเรา เรามุ่งมั่นที่จะตอบทุกคำถามที่เกี่ยวข้องกับความเป็นส่วนตัวภายใน',
        p1Strong: '5 วันทำการ'
      }
    },
    footer: {
      privacyQuestionsTitle: 'คำถามเกี่ยวกับความเป็นส่วนตัว?',
      privacyQuestionsDesc: 'ส่งคำถามเกี่ยวกับความเป็นส่วนตัว คำขอข้อมูล หรือข้อกังวลของคุณถึงเรา แล้วเราจะตอบกลับทันที',
      versionHistoryTitle: 'ประวัติเวอร์ชัน',
      v2Label: 'v2.0 — Major rewrite',
      v11Label: 'v1.1 — Added CCPA rights',
      v10Label: 'v1.0 — Initial policy'
    }
  },
common: {
    new: 'ใหม่!',
    download: 'ดาวน์โหลด',
    downloadAll: 'ดาวน์โหลดทั้งหมด',
    downloadAs: 'ดาวน์โหลดเป็น:',
    zip: 'ZIP',
    separate: 'แยกกัน',
    upload: 'อัปโหลด',
    dragDrop: 'ลากและวางรูปภาพที่นี่หรือคลิกเพื่อเรียกดู',
    remove: 'ลบ',
    reset: 'รีเซ็ต',
    apply: 'ใช้',
    cancel: 'ยกเลิก',
    clear: 'ล้าง',
    close: 'ปิด',
    save: 'บันทึก',
    processing: 'กำลังประมวลผล...',
    noFiles: 'ไม่ได้เลือกไฟล์',
    selectFiles: 'เลือกไฟล์',
    or: 'หรือ',
    browseFiles: 'เรียกดูไฟล์',
    dropHere: 'วางรูปภาพที่นี่',
    chooseFiles: 'เลือกไฟล์',
    pasteHint: 'คุณยังสามารถวางรูปภาพได้',
    quality: 'คุณภาพ',
    width: 'ความกว้าง',
    height: 'ความสูง',
    format: 'รูปแบบ',
    compression: 'การบีบอัด',
    preview: 'ดูตัวอย่าง',
    original: 'ต้นฉบับ',
    result: 'ผลลัพธ์',
    before: 'ก่อน',
    after: 'หลัง',
    startOver: 'เริ่มใหม่',
    startOverConfirm: 'ลบรูปภาพทั้งหมดและเริ่มใหม่?',
    addMoreImages: 'เพิ่มรูปภาพเพิ่มเติม',
    addImage: 'เพิ่มรูปภาพ',
    images: 'รูปภาพ',
    totalSize: 'ขนาดรวม',
    size: 'ขนาด',
    type: 'ประเภท',
    unsavedEdits: 'คุณมีการแก้ไขที่ยังไม่ได้บันทึก ออกจากหน้านี้?',
    compareSlider: 'แถบเปรียบเทียบ',
    toggleToolsPanel: 'สลับแผงเครื่องมือ',
    closePanel: 'ปิดแผง',
    zoomIn: 'ซูมเข้า',
    zoomOut: 'ซูมออก',
    fit: 'พอดี',
    none: 'ไม่มี',
  },

  compressor: {
    seo: {
      uploadTitle: 'บีบอัดรูปภาพ — บีบอัด JPG, PNG, SVG, GIF ฟรี | photremium.com',
      uploadDesc: 'บีบอัดรูปภาพ JPG, PNG, SVG และ GIF ฟรีออนไลน์ ลดขนาดไฟล์ถึง 80% พร้อมรักษาคุณภาพ',
      uploadKeywords: 'บีบอัดรูปภาพ, บีบอัด jpg, บีบอัด png, ลดขนาดรูปภาพ',
      workspaceTitle: 'กำลังบีบอัดรูปภาพ — photremium.com',
      workspaceDesc: 'ปรับระดับการบีบอัดและดาวน์โหลดรูปภาพที่ปรับให้เหมาะสม',
      workspaceKeywords: 'บีบอัดรูปภาพ, ปรับปรุงรูปภาพ',
    },
    title: 'บีบอัดรูปภาพ',
    desc: 'บีบอัดรูปภาพ JPG, PNG และ GIF ถึง 80% รวดเร็วและปลอดภัย',
    toCompress: 'เพื่อบีบอัด',
    compressionForAll: 'การบีบอัดสำหรับรูปภาพทั้งหมด',
    summary: 'สรุป',
    originalSize: 'ขนาดต้นฉบับ',
    compressed: 'บีบอัดแล้ว',
    saved: 'ประหยัดได้',
    compressionLabel: 'การบีบอัด:',
    compressing: 'กำลังบีบอัด…',
    compressDownload: 'บีบอัดและดาวน์โหลด',
    lowQualityWarning: 'การบีบอัดสูงอาจทำให้ความคมชัดของภาพลดลงอย่างเห็นได้ชัด',
    blog: {
      tocTitle: 'สารบัญ',
      title: 'บล็อกการบีบอัดรูปภาพ',
      formatsIntro: 'เครื่องมือของเรารองรับทุกรูปแบบไฟล์ภาพ คุณจึงสามารถบีบอัดรูปภาพใดก็ได้อย่างราบรื่น รายการรูปแบบทั้งหมดอยู่ด้านล่าง:',
      sections: [
        {
          id: 'imgcomp-card-1',
          title: '1. เครื่องมือบีบอัดรูปภาพคืออะไร?',
          paragraphs: [
            'เครื่องมือบีบอัดรูปภาพคือซอฟต์แวร์หรือบริการออนไลน์ที่ช่วยลดขนาดไฟล์ภาพ โดยพยายามคงคุณภาพการมองเห็นไว้ให้มากที่สุด อย่างไรก็ตาม หากบีบอัดมากเกินไป คุณภาพอาจลดลงอย่างเห็นได้ชัด',
          ],
          listTitle: 'ประเภท:',
          bullets: [
            'การบีบอัดแบบสูญเสียข้อมูล (Lossy): ลดขนาดไฟล์โดยลบบางส่วนของข้อมูลภาพ คุณภาพอาจลดลง แต่โดยทั่วไปอาจไม่สังเกตได้ชัดด้วยตาเปล่าเมื่อบีบอัดระดับกลาง',
            'การบีบอัดแบบไม่สูญเสียข้อมูล (Lossless): ลดขนาดไฟล์โดยไม่กระทบคุณภาพการมองเห็นของภาพ',
          ],
        },
        {
          id: 'imgcomp-card-2',
          title: '2. ทำไมต้องเลือกเครื่องมือของเรา?',
          bullets: [
            'เครื่องมือบีบอัดรูปภาพที่ขับเคลื่อนด้วย AI ของเราทำงานได้ลื่นไหลบนทุกอุปกรณ์และให้ผลลัพธ์ที่ดีที่สุด',
            'คุณสามารถบีบอัดรูปภาพหลายรูปพร้อมกันได้ (แม้มากกว่า 100 รูป) ด้วยคลิกเดียว',
            'ไม่ต้องอัปโหลดรูปไปยังเซิร์ฟเวอร์ของเรา ทุกอย่างประมวลผลภายในเบราว์เซอร์ของคุณ',
            'เครื่องมือของเราใช้งานฟรีตลอดไป และคุณสามารถแชร์ให้เพื่อนใช้งานได้',
            'คุณสามารถเลือกเปอร์เซ็นต์การบีบอัดได้ตามต้องการ',
          ],
        },
        {
          id: 'imgcomp-card-3',
          title: '3. วิธีใช้งานทีละขั้นตอน',
          steps: [
            {
              heading: '1. เลือกรูปภาพที่ต้องการบีบอัด',
              bullets: [
                'ลากและวางรูปภาพลงในกล่องอัปโหลด',
                'หรือคัดลอกรูปภาพแล้ววางในกล่องด้วย (Ctrl + V)',
                'สามารถเลือกไฟล์ผ่านตัวจัดการไฟล์ด้วยปุ่มเลือกไฟล์ได้',
              ],
            },
            {
              heading: '2. จากนั้นเลือกเปอร์เซ็นต์การบีบอัด',
              bullets: [
                'แถบเลื่อนแนวนอนช่วยให้เลือกเปอร์เซ็นต์การบีบอัดได้สะดวก แนะนำให้ใช้ช่วงด้านล่างเพื่อผลลัพธ์ที่แม่นยำ',
              ],
              table: {
                headers: ['เปอร์เซ็นต์การบีบอัด', 'ผลลัพธ์'],
                rows: [
                  ['1%  ถึง  40%', 'คุณภาพดีที่สุด'],
                  ['41%  ถึง  60%', 'คุณภาพปกติ (แนะนำ)'],
                  ['61%  ถึง  100%', 'คุณภาพต่ำ'],
                ],
              },
            },
            {
              heading: '3. ตรวจสอบพื้นที่ที่คุณประหยัดได้',
              paragraphs: [
                'ระบบแสดงข้อมูลขนาดไฟล์แบบเรียลไทม์ คุณจะเห็นได้ชัดว่าเซฟพื้นที่ไปเท่าไรจากทั้งหมด และสามารถปรับระดับการบีบอัดให้เหมาะกับขนาดไฟล์ที่ต้องการ',
              ],
            },
            {
              heading: '4. เลือกตัวเลือกการดาวน์โหลดจากปุ่มสลับ',
              bullets: [
                'ZIP: หากคุณบีบอัดหลายรูป จะมีตัวเลือกนี้ให้ใช้งาน เพื่อรวมไฟล์ทั้งหมดไว้ใน ZIP เดียว (เหมาะกับจำนวนรูปมาก)',
                'แยกไฟล์: ดาวน์โหลดแต่ละรูปแยกกัน ไม่รวมเป็น ZIP เดียว (เหมาะกับจำนวนรูปน้อย น้อยกว่า 10)',
              ],
            },
            {
              heading: '5. บีบอัดและดาวน์โหลดรูปภาพ',
              paragraphs: [
                'ปุ่มนี้จะดาวน์โหลดรูปภาพที่บีบอัดทั้งหมดให้อัตโนมัติตามตัวเลือกการดาวน์โหลดที่คุณเลือก',
              ],
            },
          ],
        },
        {
          id: 'imgcomp-card-4',
          title: '4. ประโยชน์ของการบีบอัดรูปภาพ',
          bullets: [
            'ลดค่าใช้จ่ายด้านพื้นที่จัดเก็บ: รูปภาพที่ถูกบีบอัดใช้พื้นที่น้อยลงอย่างชัดเจน',
            'โหลดเร็วขึ้น: รูปภาพขนาดเล็กช่วยให้เว็บไซต์หรือแอปโหลดไวขึ้นและใช้งานลื่นขึ้น',
            'แก้ปัญหาข้อจำกัด Gmail: Gmail จำกัดไฟล์แนบที่ 25MB การบีบอัดช่วยให้แนบไฟล์ได้มากขึ้น',
            'แชร์และโอนย้ายได้เร็วขึ้น: ไฟล์ใหญ่ใช้เวลาส่งนานกว่า การบีบอัดช่วยประหยัดเวลาและดาต้า',
            'เพิ่มประสิทธิภาพงานพรีเซนต์: รูปไม่บีบอัดทำให้ไฟล์งานหนักและหน่วง ขณะที่รูปบีบอัดช่วยลดขนาดไฟล์ได้มาก',
          ],
        },
        {
          id: 'imgcomp-card-5',
          title: '5. รูปแบบไฟล์ที่รองรับ',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },

  converter: {
    seo: {
      uploadTitle: 'แปลงรูปภาพ — แปลง PNG, JPG, WEBP, GIF, SVG ฟรี | photremium.com',
      uploadDesc: 'แปลงรูปภาพระหว่าง JPG, PNG, WEBP, GIF, SVG, TIFF และ BMP เครื่องมือแปลงรูปแบบออนไลน์ฟรี',
      uploadKeywords: 'แปลงรูปภาพ, png เป็น jpg, jpg เป็น png, แปลง webp',
      workspaceKeywords: 'แปลงรูปภาพ, แปลงรูปแบบรูปภาพ',

      routeKeywords: {

        'png-to-jpg': 'png เพื่อแปลง jpg, png to jpg, แปลงรูปภาพ, png เป็น jpg, jpg เป็น png, แปลง webp',

        'jpg-to-png': 'jpg เพื่อแปลง png, jpg to png, แปลงรูปภาพ, png เป็น jpg, jpg เป็น png, แปลง webp',

        'png-to-webp': 'png เพื่อแปลง webp, png to webp, แปลงรูปภาพ, png เป็น jpg, jpg เป็น png, แปลง webp',

        'jpg-to-webp': 'jpg เพื่อแปลง webp, jpg to webp, แปลงรูปภาพ, png เป็น jpg, jpg เป็น png, แปลง webp',

        'webp-to-jpg': 'webp เพื่อแปลง jpg, webp to jpg, แปลงรูปภาพ, png เป็น jpg, jpg เป็น png, แปลง webp',

        'webp-to-png': 'webp เพื่อแปลง png, webp to png, แปลงรูปภาพ, png เป็น jpg, jpg เป็น png, แปลง webp',

        'gif-to-jpg': 'gif เพื่อแปลง jpg, gif to jpg, แปลงรูปภาพ, png เป็น jpg, jpg เป็น png, แปลง webp',

        'gif-to-png': 'gif เพื่อแปลง png, gif to png, แปลงรูปภาพ, png เป็น jpg, jpg เป็น png, แปลง webp',

        'bmp-to-jpg': 'bmp เพื่อแปลง jpg, bmp to jpg, แปลงรูปภาพ, png เป็น jpg, jpg เป็น png, แปลง webp',

        'bmp-to-png': 'bmp เพื่อแปลง png, bmp to png, แปลงรูปภาพ, png เป็น jpg, jpg เป็น png, แปลง webp',

        'svg-to-png': 'svg เพื่อแปลง png, svg to png, แปลงรูปภาพ, png เป็น jpg, jpg เป็น png, แปลง webp',

        'svg-to-jpg': 'svg เพื่อแปลง jpg, svg to jpg, แปลงรูปภาพ, png เป็น jpg, jpg เป็น png, แปลง webp',

        'tiff-to-jpg': 'tiff เพื่อแปลง jpg, tiff to jpg, แปลงรูปภาพ, png เป็น jpg, jpg เป็น png, แปลง webp',

        'tiff-to-png': 'tiff เพื่อแปลง png, tiff to png, แปลงรูปภาพ, png เป็น jpg, jpg เป็น png, แปลง webp',

        'jpg-to-gif': 'jpg เพื่อแปลง gif, jpg to gif, แปลงรูปภาพ, png เป็น jpg, jpg เป็น png, แปลง webp',

        'png-to-gif': 'png เพื่อแปลง gif, png to gif, แปลงรูปภาพ, png เป็น jpg, jpg เป็น png, แปลง webp',

        'jpg-to-bmp': 'jpg เพื่อแปลง bmp, jpg to bmp, แปลงรูปภาพ, png เป็น jpg, jpg เป็น png, แปลง webp',

        'png-to-bmp': 'png เพื่อแปลง bmp, png to bmp, แปลงรูปภาพ, png เป็น jpg, jpg เป็น png, แปลง webp',

        'webp-to-gif': 'webp เพื่อแปลง gif, webp to gif, แปลงรูปภาพ, png เป็น jpg, jpg เป็น png, แปลง webp',

        'jpg-to-ico': 'jpg เพื่อแปลง ico, jpg to ico, แปลงรูปภาพ, png เป็น jpg, jpg เป็น png, แปลง webp',

        'png-to-ico': 'png เพื่อแปลง ico, png to ico, แปลงรูปภาพ, png เป็น jpg, jpg เป็น png, แปลง webp',

        'jpg-to-svg': 'jpg เพื่อแปลง svg, jpg to svg, แปลงรูปภาพ, png เป็น jpg, jpg เป็น png, แปลง webp',

        'png-to-svg': 'png เพื่อแปลง svg, png to svg, แปลงรูปภาพ, png เป็น jpg, jpg เป็น png, แปลง webp',

        'webp-to-svg': 'webp เพื่อแปลง svg, webp to svg, แปลงรูปภาพ, png เป็น jpg, jpg เป็น png, แปลง webp',

        'gif-to-svg': 'gif เพื่อแปลง svg, gif to svg, แปลงรูปภาพ, png เป็น jpg, jpg เป็น png, แปลง webp',

        'bmp-to-svg': 'bmp เพื่อแปลง svg, bmp to svg, แปลงรูปภาพ, png เป็น jpg, jpg เป็น png, แปลง webp',

        'tiff-to-svg': 'tiff เพื่อแปลง svg, tiff to svg, แปลงรูปภาพ, png เป็น jpg, jpg เป็น png, แปลง webp',

      },
    },
    title: 'แปลงรูปภาพ',
    desc: 'แปลงรูปภาพระหว่าง JPG, PNG, WEBP, GIF, SVG, TIFF และ BMP แปลงหลายไฟล์พร้อมกัน',
    toConvert: 'เพื่อแปลง',
    convertSettings: 'การตั้งค่าการแปลง',
    detected: 'ตรวจพบ',
    convertTo: 'แปลงเป็น',
    converting: 'กำลังแปลง…',
    convertToFormat: 'แปลงเป็น {format}',
    popularConversions: 'การแปลงยอดนิยม',
    convertingTo: 'กำลังแปลงเป็น',
    all: 'ทั้งหมด',
  },

  resizer: {
    seo: {
      uploadTitle: 'ปรับขนาดรูปภาพ — ปรับขนาด JPG, PNG ฟรี | photremium.com',
      uploadDesc: 'ปรับขนาดรูปภาพเป็นพิกเซลหรือเปอร์เซ็นต์ฟรีออนไลน์',
      uploadKeywords: 'ปรับขนาดรูปภาพ, เครื่องมือปรับขนาด, ปรับขนาด jpg, ปรับขนาด png',
      workspaceTitle: 'ปรับขนาดรูปภาพ — photremium.com',
      workspaceDesc: 'ปรับขนาดรูปภาพฟรีออนไลน์',
      workspaceKeywords: 'ปรับขนาดรูปภาพ, เครื่องมือปรับขนาด',
    },
    title: 'ปรับขนาดรูปภาพ',
    desc: 'ระบุขนาดเป็นพิกเซล เปอร์เซ็นต์ เซนติเมตร หรือนิ้ว และปรับขนาดทันที',
    toResize: 'เพื่อปรับขนาด',
    resizeSettings: 'การตั้งค่าขนาด',
    resizeBy: 'ปรับขนาดตาม:',
    byPixels: 'พิกเซล',
    byPercentage: 'เปอร์เซ็นต์',
    byCentimeters: 'เซนติเมตร',
    byInches: 'นิ้ว',
    advanced: 'ขั้นสูง',
    lockAspect: 'ล็อคสัดส่วน',
    unlockAspect: 'ปลดล็อคสัดส่วน',
    dontEnlarge: 'ไม่ขยายถ้าต้นฉบับเล็กกว่า',
    resizing: 'กำลังปรับขนาด…',
    resizeDownload: 'ปรับขนาดและดาวน์โหลด',
    blog: {
      tocTitle: 'สารบัญ',
      title: 'บล็อกการปรับขนาดรูปภาพ',
      sections: [
        {
          id: 'imgresize-card-1',
          title: '1. ทำไมต้องใช้เครื่องมือปรับขนาดรูปภาพ?',
          paragraphs: [
            'เครื่องมือปรับขนาดรูปภาพคือซอฟต์แวร์/เครื่องมือที่ใช้เปลี่ยนมิติของรูปภาพ คุณสามารถปรับความสูง ความกว้าง หรือทั้งสองอย่างให้ได้ขนาดที่ต้องการ เหมาะมากสำหรับแพลตฟอร์มโซเชียลที่มีข้อจำกัดขนาดไฟล์หรือขนาดภาพในการโพสต์',
          ],
          listTitle: 'ตัวอย่างเช่น:',
          bullets: [
            'โพสต์ Instagram: 1080 x 1080px (สี่เหลี่ยมจัตุรัส)',
            'โพสต์ Facebook: 1200 x 630px',
            'โพสต์ X (Twitter): 1200 x 675px',
            'Instagram Story: 1080 x 1920px',
          ],
        },
        {
          id: 'imgresize-card-2',
          title: '2. ทำไมต้องเลือกเครื่องมือปรับขนาดของเรา?',
          paragraphs: [
            'เครื่องมือปรับขนาดรูปภาพด้วย AI ของเราช่วยให้คุณปรับขนาดได้แม่นยำและรวดเร็วมาก ใช้งานได้ลื่นบนทุกอุปกรณ์ และไม่ต้องติดตั้งแอป ทุกฟีเจอร์ใช้งานได้ออนไลน์บนเบราว์เซอร์ของคุณ',
          ],
          bullets: [
            'คุณสามารถปรับขนาดหลายรูปพร้อมกันได้ (แม้แต่ 100+) และหากอุปกรณ์แรงพอ สามารถประมวลผล 400–500 รูปได้ในไม่กี่วินาที',
            'ทุกอย่างประมวลผลในเบราว์เซอร์บนเครื่องของคุณ ไม่ต้องอัปโหลดขึ้นเซิร์ฟเวอร์ รูปจึงไม่ออกจากอุปกรณ์',
            'รองรับหน่วยการปรับขนาดหลายรูปแบบ',
            'สามารถคงอัตราส่วนภาพได้ด้วยการติ๊กเพียงช่องเดียว',
            'เมื่อปรับหลายรูป คุณสามารถดาวน์โหลดแยกไฟล์หรือรวมเป็น ZIP ได้',
          ],
        },
        {
          id: 'imgresize-card-3',
          title: '3. คู่มือทีละขั้นตอน',
          steps: [
            {
              heading: 'เริ่มจากเลือกรูปภาพที่ต้องการปรับขนาด (หนึ่งหรือหลายรูป) โดยมีหลายวิธีให้เลือก',
              bullets: [
                'ลากและวางรูปภาพลงในกล่องอัปโหลด',
                'หรือวางรูปด้วยคีย์ลัด “Ctrl + V”',
                'หรือกดปุ่ม “Choose Files” เพื่อเลือกจากตัวจัดการไฟล์',
              ],
            },
            {
              heading: 'จากนั้นเลือกหน่วยการปรับขนาด หน่วยที่รองรับตอนนี้คือ:',
              bullets: ['Pixels', 'Percentage', 'Centimeters', 'Inches'],
            },
            {
              heading: 'หลังเลือกหน่วยแล้ว ให้ตั้งค่าความสูงและความกว้างตามต้องการ และสามารถคงอัตราส่วนได้ด้วยช่องเลือก',
            },
            {
              heading: 'หากไม่ต้องการขยายเกินขนาดต้นฉบับ ให้เลือก “Don’t enlarge if original is smaller”',
            },
            {
              heading: 'ต่อไปให้เลือกวิธีดาวน์โหลด',
              bullets: [
                'เลือก ZIP หากต้องการดาวน์โหลดรูปที่ปรับแล้วทั้งหมดเป็นไฟล์ zip เดียว',
                'เลือก “separate” หากต้องการดาวน์โหลดทีละรูปแยกกัน',
              ],
            },
            {
              heading: 'สุดท้ายกด “Resize & Download” เพื่อดาวน์โหลดตามตัวเลือกที่เลือกไว้',
            },
          ],
        },
        {
          id: 'imgresize-card-4',
          title: '4. ประโยชน์ของเครื่องมือปรับขนาด: จุดเด่นสำคัญคือช่วยให้ภาพพอดีกับหน้าเว็บและโพสต์โซเชียลมีเดียได้อย่างถูกต้อง',
          tocLabel: '4. ประโยชน์ของเครื่องมือปรับขนาด',
          bullets: [
            'ปรับปรุง UX: ขนาดและตำแหน่งภาพที่ถูกต้องช่วยให้ประสบการณ์ผู้ใช้ดีขึ้นมาก',
            'รองรับโซเชียลมีเดีย: หลายแพลตฟอร์มมีข้อกำหนดขนาดภาพ เครื่องมือนี้ช่วยให้ทำตามได้ง่าย',
            'รองรับงาน responsive: นักพัฒนาต้องใช้หลายขนาดภาพเพื่อรองรับอุปกรณ์ที่แตกต่างกัน',
            'เป็นตัวเลือกที่ดีกว่า: แทนการยืดหรือครอปรุนแรงที่ทำให้ภาพเพี้ยน การปรับขนาดมักให้ผลลัพธ์ที่ดีกว่า',
          ],
        },
        {
          id: 'imgresize-card-5',
          title: '5. ฟอร์แมตที่รองรับ: เครื่องมือปรับขนาดของเรารองรับการเลือกรูปภาพได้ทุกฟอร์แมต รายการที่รองรับมีดังนี้:',
          tocLabel: '5. ฟอร์แมตที่รองรับ',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },

  cropper: {
    seo: {
      uploadTitle: 'ครอปรูปภาพ — ครอป JPG, PNG, GIF ฟรี | photremium.com',
      uploadDesc: 'ครอปรูปภาพ JPG, PNG และ GIF ได้อย่างง่ายดายฟรีออนไลน์',
      uploadKeywords: 'ครอปรูปภาพ, เครื่องมือครอป, ครอป jpg, ครอป png',
      workspaceTitle: 'ครอปรูปภาพ — photremium.com',
      workspaceDesc: 'ครอปรูปภาพฟรีออนไลน์',
      workspaceKeywords: 'ครอปรูปภาพ, เครื่องมือครอป',
    },
    title: 'ครอปรูปภาพ',
    desc: 'ครอป JPG, PNG, GIF และอื่นๆ ด้วยตัวแก้ไขแบบภาพ อัตราส่วนที่กำหนดไว้หรือแบบอิสระ',
    toCrop: 'เพื่อครอป',
    cropSettings: 'การตั้งค่าการครอป',
    widthPx: 'ความกว้าง (px)',
    heightPx: 'ความสูง (px)',
    positionX: 'ตำแหน่ง X (px)',
    positionY: 'ตำแหน่ง Y (px)',
    cropTemplate: 'เทมเพลตการครอป',
    landscape: 'แนวนอน',
    portrait: 'แนวตั้ง',
    square: 'สี่เหลี่ยมจัตุรัส',
    freeform: 'อิสระ',
    cropping: 'กำลังครอป…',
    cropDownload: 'ครอปและดาวน์โหลด',
    cropDownloadAll: 'ครอปและดาวน์โหลดทั้งหมด',
    saveNext: 'บันทึกและถัดไป',
    croppedNofTotal: 'ครอปแล้ว {n} จาก {total}',
    downloadN: 'ดาวน์โหลด {n}',
    blog: {
      tocTitle: 'สารบัญ',
      title: 'บล็อกเครื่องมือครอปรูปภาพ',
      sections: [
        {
          id: 'imgcrop-card-1',
          title: '1. ทำไมต้องใช้เครื่องมือครอปรูปภาพ?',
          paragraphs: [
            'เครื่องมือครอปรูปภาพคือซอฟต์แวร์ที่ใช้ครอปรูปภาพให้ได้รูปทรงตามต้องการ นิยมใช้เพื่อตัดเฉพาะส่วนที่ต้องการและลบพื้นที่รอบนอกที่ไม่ต้องการสำหรับทุกวัตถุประสงค์ เครื่องมือนี้มีกรอบครอปที่คุณสามารถปรับตำแหน่งได้ตามจุดที่ต้องการครอป',
          ],
          listTitle: 'ตัวอย่างเช่น:',
          bullets: [
            'ครอปตัวคุณออกจากรูปหมู่',
            'ครอปชื่อของคุณออกจากรายการ',
            'ครอปแถบความคืบหน้าจากภาพหน้าจอเต็มจอ',
          ],
        },
        {
          id: 'imgcrop-card-2',
          title: '2. ทำไมต้องเลือกเครื่องมือครอปรูปภาพของเรา?',
          paragraphs: [
            'เครื่องมือครอปรูปภาพของเราช่วยให้คุณครอปรูปได้แม่นยำและรวดเร็วมาก คุณเพียงปรับขนาดกรอบครอปให้ตรงตำแหน่งที่ต้องการบนรูปใดก็ได้ โดยรองรับไฟล์รูปภาพแทบทุกฟอร์แมตในการเลือกไฟล์',
          ],
          bullets: [
            'คุณสามารถครอปรูปได้ตามจำนวนที่อุปกรณ์รองรับ หากอุปกรณ์ของคุณประสิทธิภาพสูง คุณสามารถครอปได้มากกว่า 100 รูปพร้อมกันโดยไม่หน่วงหรือมีปัญหาอื่น',
            'รูปภาพของคุณถูกประมวลผลในเบราว์เซอร์บนเครื่องของคุณเอง ไม่ต้องอัปโหลดรูปไปยังเซิร์ฟเวอร์ของเรา จึงไม่มีรูปใดออกจากอุปกรณ์ คุณสามารถครอปรูปส่วนตัวได้อย่างปลอดภัย',
            'หลายเครื่องมือมักแจ้งข้อผิดพลาดรูปแบบไฟล์ไม่ถูกต้อง แต่เครื่องมือครอปรูปภาพของเราจัดการปัญหานี้ด้วยการรองรับฟอร์แมตรูปภาพเกือบทั้งหมด',
            'หากคุณครอปหลายรูปพร้อมกัน เครื่องมือของเราช่วยให้ดาวน์โหลดรูปที่ครอปแล้วได้ทั้งแบบ ZIP หรือดาวน์โหลดแยกไฟล์ตามที่ต้องการ',
          ],
        },
        {
          id: 'imgcrop-card-3',
          title: '3. คู่มือทีละขั้นตอน',
          steps: [
            {
              heading: '1. ขั้นแรก เลือกรูปภาพที่คุณต้องการครอป เครื่องมือครอปรูปภาพของเรารองรับการเลือกหลายรูปพร้อมกันด้วย',
              bullets: [
                'ลากและวางรูปภาพลงในกล่องวางไฟล์เพื่อครอป',
                'คุณยังสามารถเลือกไฟล์ผ่านตัวสำรวจไฟล์ โดยคลิกปุ่ม choose files ในกล่องครอป',
                'รองรับคีย์ลัด Ctrl + V สำหรับวางรูปภาพลงในกล่องวางไฟล์ด้วย',
              ],
            },
            {
              heading: '2. จากนั้น ปรับขนาดและตำแหน่งของกรอบครอปบนรูปภาพเพื่อครอป',
            },
            {
              heading: '3. คุณยังสามารถปรับกรอบครอปโดยกรอกค่าความสูง ความกว้าง ตำแหน่งแนวนอน และตำแหน่งแนวตั้งแบบกำหนดเองได้',
            },
            {
              heading: '4. คุณยังสามารถใช้เทมเพลตสำเร็จรูปได้หลายแบบ:',
              bullets: [
                'Landscape(16:9)',
                'Portrait(9:16)',
                'Square(1:1)',
              ],
            },
            {
              heading: '5. จากนั้นคุณต้องเลือกตัวเลือกการดาวน์โหลดอย่างใดอย่างหนึ่ง',
              bullets: [
                'ZIP: เลือกตัวเลือกนี้หากคุณครอปหลายรูปและต้องการดาวน์โหลดรูปที่ครอปทั้งหมดเป็นไฟล์เดียว',
                'Separate: หากต้องการดาวน์โหลดรูปที่ครอปแล้วแยกเป็นรายไฟล์ ให้เลือกตัวเลือกนี้จากปุ่มสลับ',
              ],
            },
            {
              heading: '6. จากนั้นคลิกปุ่ม Crop & Download เพื่อดาวน์โหลดรูปที่ครอปทั้งหมดตามมิติที่คุณตั้งไว้',
            },
          ],
        },
        {
          id: 'imgcrop-card-4',
          title: '4. ประโยชน์ของการครอปรูปภาพ: เครื่องมือครอปรูปภาพมอบประโยชน์หลายด้านในโลกดิจิทัล ซึ่งบางส่วนมีดังนี้:',
          tocLabel: '4. ประโยชน์ของการครอปรูปภาพ',
          bullets: [
            'จัดรูปภาพให้พอดีกับเฟรม: เครื่องมือครอปรูปช่วยให้คุณวางรูปภาพในเฟรมได้อย่างถูกต้อง เฟรมนี้อาจอยู่บนหน้าเว็บหรือแพลตฟอร์มโซเชียลมีเดียใดก็ได้',
            'ปรับปรุง UX: เมื่อการจัดวางรูปภาพที่เหมาะสมช่วยเพิ่มประสบการณ์ผู้ใช้ เครื่องมือครอปรูปจึงช่วยยกระดับ UX ได้อย่างมาก',
            'ลบขอบที่ไม่ต้องการ: คุณสามารถลบขอบส่วนเกินของรูปเพื่อให้ภาพดูเรียบร้อยขึ้น',
            'แยกวัตถุที่ต้องการ: คุณสามารถแยกตัวคุณเองออกจากรูปหมู่ได้เช่นกัน',
            'ประหยัดพื้นที่จัดเก็บ: การครอปรูปช่วยประหยัดพื้นที่ เพราะส่วนเกินของภาพจะถูกตัดออกและคงไว้เฉพาะส่วนที่ต้องการ',
            'ปรับการนำเสนอให้เหมาะสม: หากงานนำเสนอทั่วไปที่มีภาพไม่ครอป 10 ภาพใช้พื้นที่ประมาณ 30MB งานนำเสนอเดียวกันเมื่อใช้ภาพที่ครอปแล้วอาจใช้เพียงประมาณ 10MB',
          ],
        },
        {
          id: 'imgcrop-card-5',
          title: '5. ฟอร์แมตที่รองรับ:',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },

  photoEditor: {
    seo: {
      title: 'แก้ไขรูปภาพออนไลน์ — แก้ไขฟรีพร้อมข้อความ เอฟเฟกต์ กรอบ | photremium.com',
      desc: 'แก้ไขรูปภาพออนไลน์ฟรี — เพิ่มข้อความ เอฟเฟกต์ กรอบ สติกเกอร์ ทำงานในเบราว์เซอร์',
      keywords: 'แก้ไขรูปภาพ, แก้ไขรูปภาพออนไลน์, แก้ไขรูปภาพออนไลน์ฟรี',
    },
    title: 'แก้ไขรูปภาพ',
    desc: 'ตกแต่งรูปภาพด้วยข้อความ เอฟเฟกต์ กรอบ และสติกเกอร์',
    toEdit: 'เพื่อแก้ไข',
    textTypography: 'ข้อความและตัวอักษร',
    textTypographyDesc: 'เพิ่มข้อความพร้อมแบบอักษร สี เงา และตัวเลือกตำแหน่งที่หลากหลาย',
    filtersEffects: 'ฟิลเตอร์และเอฟเฟกต์',
    filtersEffectsDesc: 'ใช้ฟิลเตอร์มืออาชีพและปรับความสว่าง ความคมชัด และความอิ่มตัว',
    framesStickers: 'กรอบและสติกเกอร์',
    framesStickersDesc: 'เลือกกรอบสวยงามและสติกเกอร์สนุกๆ เพื่อตกแต่งรูปภาพ',
  },

  removeBg: {
    seo: {
      uploadTitle: 'ลบพื้นหลังรูปภาพฟรี | photremium.com',
      uploadDesc: 'ลบพื้นหลังรูปภาพได้อย่างรวดเร็วและแม่นยำ เครื่องมือออนไลน์ฟรี',
      uploadKeywords: 'ลบพื้นหลัง, การลบพื้นหลัง, ลบพื้นหลังรูปภาพ, พื้นหลังโปร่งใส',
      workspaceTitle: 'ลบพื้นหลัง — photremium.com',
      workspaceDesc: 'ลบพื้นหลังรูปภาพฟรีออนไลน์',
      workspaceKeywords: 'ลบพื้นหลัง, พื้นหลังโปร่งใส',
    },
    title: 'ลบพื้นหลัง',
    desc: 'ลบพื้นหลังรูปภาพทันทีด้วยการตรวจจับขอบขั้นสูง ฟรี 100% ทำงานในเบราว์เซอร์',
    toRemoveBg: 'เพื่อลบพื้นหลัง',
    backgroundRemover: 'เครื่องมือลบพื้นหลัง',
    processingProgress: 'ความคืบหน้าการประมวลผล',
    processingNImages: 'กำลังประมวลผล {n} รูปภาพ…',
    allNProcessed: 'ประมวลผล {n} รูปภาพทั้งหมดแล้ว!',
    nOfTotalDone: '{n} / {total} เสร็จแล้ว',
    fileName: 'ชื่อไฟล์',
    dimensions: 'ขนาด',
    status: 'สถานะ',
    statusDone: '✓ เสร็จแล้ว',
    statusProcessing: '⏳ กำลังประมวลผล',
    statusError: '✗ ข้อผิดพลาด',
    statusPending: '⏸ รอดำเนินการ',
    badgeDone: 'เสร็จแล้ว',
    badgeProcessing: 'กำลังประมวลผล…',
    badgeError: 'ข้อผิดพลาด',
    removingBg: 'กำลังลบพื้นหลัง…',
    retry: 'ลองอีกครั้ง',
    downloading: 'กำลังดาวน์โหลด…',
    nextImage: 'รูปภาพถัดไป',
  },

  watermark: {
    seo: {
      uploadTitle: 'ใส่ลายน้ำ — เพิ่มลายน้ำข้อความและโลโก้ฟรี | photremium.com',
      uploadDesc: 'เพิ่มลายน้ำข้อความหรือรูปภาพบนรูปภาพในไม่กี่วินาที ฟรีและรวดเร็ว',
      uploadKeywords: 'ใส่ลายน้ำ, เพิ่มลายน้ำ, ลายน้ำข้อความ',
      workspaceTitle: 'ใส่ลายน้ำ — photremium.com',
      workspaceDesc: 'เพิ่มลายน้ำบนรูปภาพฟรีออนไลน์',
      workspaceKeywords: 'ใส่ลายน้ำ, เพิ่มลายน้ำ',
    },
    title: 'ใส่ลายน้ำ',
    desc: 'เพิ่มลายน้ำข้อความหรือโลโก้บนรูปภาพ ปรับแต่งแบบอักษร ความโปร่งใส ขนาด และตำแหน่ง',
    toWatermark: 'เพื่อใส่ลายน้ำ',
    watermarkTools: 'เครื่องมือลายน้ำ',
    addText: 'เพิ่มข้อความ',
    addImage: 'เพิ่มรูปภาพ',
    layersN: 'เลเยอร์ ({n})',
    noLayers: 'ยังไม่มีเลเยอร์',
    textLayer: 'เลเยอร์ข้อความ',
    imageLayer: 'เลเยอร์รูปภาพ',
    watermarkDownloadAll: 'ใส่ลายน้ำและดาวน์โหลดทั้งหมด',
    watermarkDownload: 'ใส่ลายน้ำและดาวน์โหลด',
    nextImage: 'รูปภาพถัดไป',
    selectToEdit: 'เลือกรูปภาพหรือข้อความใดๆ เพื่อเริ่มแก้ไข',
    bold: 'ตัวหนา',
    italic: 'ตัวเอียง',
    underline: 'ขีดเส้นใต้',
    bgColor: 'สีพื้นหลัง',
    textColor: 'สีข้อความ',
    alignLeft: 'ชิดซ้าย',
    alignCenter: 'กึ่งกลาง',
    alignRight: 'ชิดขวา',
    opacity: 'ความโปร่งใส',
    stroke: 'เส้นขอบ',
    strokeWidth: 'ความกว้างเส้นขอบ',
    strokeColor: 'สีเส้นขอบ',
    tileRepeat: 'ลวดลาย/ซ้ำ',
    tilePattern: 'รูปแบบลวดลาย',
    spacing: 'ระยะห่าง',
    snapToCenter: 'ยึดกึ่งกลาง',
    duplicate: 'ทำซ้ำ',
    delete: 'ลบ',
    flipHorizontal: 'พลิกแนวนอน',
    flipVertical: 'พลิกแนวตั้ง',
    rotateLeft: 'หมุนซ้าย',
    rotateRight: 'หมุนขวา',
    cornerRadius: 'รัศมีมุม',
    borderStroke: 'กรอบ/เส้นขอบ',
    borderWidth: 'ความกว้างกรอบ',
    color: 'สี',
    style: 'สไตล์',
    hide: 'ซ่อน',
    show: 'แสดง',
    lock: 'ล็อค',
    unlock: 'ปลดล็อค',
    solid: 'ทึบ',
    dashed: 'เส้นประ',
    dotted: 'จุดประ',
    double: 'คู่',
    tileSingle: 'เดี่ยว',
    tile2x2: 'ตาราง 2×2',
    tile3x3: 'ตาราง 3×3',
    removeAllConfirm: 'ลบรูปภาพและลายน้ำทั้งหมด?',
    dimMismatch: 'รูปภาพที่อัปโหลดมีขนาดต่างกัน สำหรับผลลัพธ์ที่ดีที่สุดอัปโหลดรูปภาพที่มีความละเอียดเท่ากัน',
    clearBackground: 'ล้างพื้นหลัง',
    typeHere: 'พิมพ์ที่นี่...',
    linkCorners: 'เชื่อมมุม',
    separateCorners: 'แยกมุม',
    blog: {
      tocTitle: 'สารบัญ',
      sections: [
        {
          id: 'wm-blog-intro',
          tocLabel: 'ภาพรวมเครื่องมือลายน้ำ',
          title: 'วิธีเพิ่มลายน้ำให้รูปภาพออนไลน์ — คู่มือฉบับสมบูรณ์ของเครื่องมือลายน้ำ Photremium',
          paragraphs: [
            'คุณเพิ่งแก้ไขภาพถ่ายสวยๆ เสร็จ อาจเป็นภาพสินค้าเพื่อร้านค้า ภาพพอร์ตเทรตจากเซสชันลูกค้า หรือผลงานศิลปะดิจิทัลที่คุณใช้เวลาขัดเกลาหลายชั่วโมง และตอนนี้คำถามที่ครีเอเตอร์ทุกคนต้องเจอในที่สุดก็มาถึง: จะปกป้องมันก่อนแชร์อย่างไร?',
            'คำตอบที่มืออาชีพส่วนใหญ่เลือกคือ: ลายน้ำ — และมีเหตุผลที่ดี ลายน้ำที่วางอย่างเหมาะสมทำหน้าที่เหมือนลายเซ็นถาวร ทำให้งานของคุณติดตามได้ มีแบรนด์ชัดเจน และยากต่อการขโมยมากขึ้น',
            'ปัญหาที่คนส่วนใหญ่เจอคือเครื่องมือออนไลน์ที่มีอยู่มักใช้งานยุ่งยาก ถูกล็อกด้วยค่าสมัคร หรือสร้างลายน้ำที่หนาเกินไปจนทำลายภาพทั้งหมด',
            'เครื่องมือลายน้ำของ Photremium ถูกสร้างมาเพื่อแก้ปัญหาเหล่านี้ มันคือพื้นที่ทำงานลายน้ำที่ทำงานบนเบราว์เซอร์ทั้งหมด ฟรี ไม่ต้องมีบัญชี และไม่อัปโหลดไฟล์ของคุณไปยังเซิร์ฟเวอร์ ทุกอย่างทำงานในเครื่องของคุณ เร็ว และให้การควบคุมเชิงสร้างสรรค์ในระดับที่เทียบได้กับซอฟต์แวร์เดสก์ท็อป ในคู่มือนี้เราจะพาคุณดูว่ามันทำงานอย่างไร เหมาะกับใคร และทำอย่างไรให้ได้ผลลัพธ์ที่ดีที่สุดทุกครั้ง',
          ],
        },
        {
          id: 'wm-blog-what-is',
          tocLabel: 'ลายน้ำคืออะไร',
          title: 'ลายน้ำคืออะไร และทำไมจึงสำคัญ?',
          paragraphs: [
            'ก่อนจะลงรายละเอียดของเครื่องมือ ควรเข้าใจว่าลายน้ำทำอะไร และเหตุใดช่างภาพ นักออกแบบ และครีเอเตอร์จำนวนมากจึงมองว่ามันขาดไม่ได้',
            'ลายน้ำคือการซ้อนทับที่มองเห็นได้บนภาพ — มักเป็นข้อความ โลโก้ หรือสัญลักษณ์ลิขสิทธิ์ — เพื่อระบุผู้สร้างหรือเจ้าของเนื้อหา ต่างจากเมทาดาทา (ที่ซ่อนอยู่ในไฟล์และลบได้ในไม่กี่วินาที) ลายน้ำฝังอยู่ในภาพอย่างเห็นได้ชัด คุณไม่สามารถคลิกขวาแล้วลบออกโดยไม่ทำให้คุณภาพภาพเสื่อมลงอย่างชัดเจน',
          ],
          subSections: [
            {
              title: 'ทำไมครีเอเตอร์ถึงใช้ลายน้ำ',
              paragraphs: [
                'เหตุผลเชิงปฏิบัติสำหรับการใส่ลายน้ำมักสรุปได้เป็นสามประเด็นหลัก',
              ],
              bullets: [
                'การระบุความเป็นเจ้าของ เมื่อผลงานของคุณถูกแชร์บนโซเชียลมีเดีย บอร์ด Pinterest หรือฝังในบทความ บางครั้งเครดิตต้นฉบับจะหายไป ลายน้ำช่วยให้ชื่อหรือแบรนด์ของคุณติดไปกับภาพทุกที่',
                'ยับยั้งการขโมย ผู้ขโมยภาพแบบทั่วไปมักหาทางที่ง่ายที่สุด ลายน้ำที่ดูเป็นมืออาชีพ วางตำแหน่งดี และโปร่งใสเล็กน้อย จะส่งสัญญาณชัดเจนว่า: ภาพนี้เป็นของคนที่ใส่ใจงานของตัวเอง',
                'ปกป้องพอร์ตโฟลิโอลูกค้า ช่างภาพที่ส่งพรีวิวให้ลูกค้าก่อนชำระเงินขั้นสุดท้ายมักใส่ลายน้ำเพื่อป้องกันการใช้พรีวิวโดยไม่จ่ายเงิน ลายน้ำที่ละเอียดอ่อนช่วยปกป้องได้โดยไม่ทำให้การประเมินงานรบกวนมากเกินไป',
              ],
            },
            {
              title: 'ใครควรใส่ลายน้ำให้รูปภาพ',
              paragraphs: [
                'หากคุณอยู่ในกลุ่มใดกลุ่มหนึ่งต่อไปนี้ การใส่ลายน้ำก่อนแชร์ออนไลน์ไม่ใช่ตัวเลือก — แต่เป็นสิ่งจำเป็น:',
              ],
              bullets: [
                'ช่างภาพฟรีแลนซ์ที่แชร์แกลเลอรีกับลูกค้า',
                'นักออกแบบกราฟิกที่แจกตัวอย่างพอร์ตโฟลิโอ',
                'ผู้ขายอีคอมเมิร์ซที่โชว์ภาพสินค้าก่อนข้อตกลงไลเซนส์',
                'ศิลปินดิจิทัลที่แชร์ผลงานบนแพลตฟอร์มโซเชียล',
                'บล็อกเกอร์และครีเอเตอร์ที่ภาพถูกนำไปใช้ซ้ำเป็นประจำ',
                'ผู้ส่งภาพสต็อกที่สร้างแบรนด์ให้เป็นที่จดจำ',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-workspace',
          tocLabel: 'แผงพื้นที่ทำงาน',
          title: 'ภายในเครื่องมือลายน้ำ Photremium: พื้นที่ทำงานสามแผงเพื่อเวิร์กโฟลว์จริง',
          paragraphs: [
            'สิ่งที่ทำให้เครื่องมือลายน้ำของ Photremium แตกต่างจากตัวที่เป็นพื้นฐานออนไลน์คือการออกแบบพื้นที่ทำงาน แทนที่จะเป็นแค่ “พิมพ์ข้อความ เลือกตำแหน่ง เสร็จ” เครื่องมือนี้มีเลย์เอาต์สามแผงคล้ายซอฟต์แวร์ออกแบบระดับมืออาชีพ — แต่ทำงานในเบราว์เซอร์ทั้งหมดโดยไม่ต้องติดตั้ง',
          ],
          subSections: [
            {
              title: 'แผงแคนวาสด้านซ้าย',
              paragraphs: [
                'แผงแคนวาสกินพื้นที่ใหญ่ที่สุดของหน้าจอและแสดงภาพพร้อมลายน้ำแบบเรียลไทม์ ทุกการเปลี่ยนแปลง — ปรับความโปร่งใส ย้ายเลเยอร์ข้อความ ปรับขนาดโลโก้ — จะสะท้อนทันทีบนแคนวาส ไม่มีปุ่ม “พรีวิว” ให้กด สิ่งที่เห็นคือสิ่งที่ได้',
                'แคนวาสมีแถบเครื่องมือซูมในตัว ช่วยให้คุณซูมเข้าเพื่อจัดแนวให้แม่นยำ และซูมออกเพื่อดูภาพรวม ฟีเจอร์ zoom-to-fit จะคำนวณสเกลเริ่มต้นที่เหมาะสมโดยอัตโนมัติตามขนาดหน้าจอ ทำให้ภาพความละเอียดสูงดูทำงานได้สบาย เมื่อคุณลากเลเยอร์เข้าใกล้จุดกึ่งกลางแนวนอนหรือแนวตั้ง เส้นไกด์จะปรากฏและสแนปลายน้ำเข้ากลางอย่างแม่นยำ เหมือนที่ได้จาก Photoshop',
              ],
            },
            {
              title: 'แผงตั้งค่าด้านขวา',
              paragraphs: [
                'แผงด้านขวาคือศูนย์ควบคุม ที่นี่คุณจัดการเลเยอร์ลายน้ำ ปรับรูปลักษณ์ และสั่งเอ็กซ์พอร์ตขั้นสุดท้าย บนเดสก์ท็อปมันจะยึดอยู่ทางขวา บนมือถือมันเลื่อนขึ้นเป็นแผงด้านล่าง — เปิดด้วยปุ่มเฟืองลอย — เพื่อไม่ให้บังแคนวาสขณะทำงาน',
                'ภายในแผงขวามีตัวจัดการเลเยอร์ที่แสดงองค์ประกอบลายน้ำทั้งหมดที่คุณเพิ่ม แต่ละรายการแสดงประเภทเลเยอร์ (ข้อความหรือรูปภาพ) ชื่อหรือเนื้อหา และปุ่มลัดสามตัว: สลับการมองเห็น (ไอคอนตา), ล็อกตำแหน่ง และลบ',
              ],
            },
            {
              title: 'แถบพรีวิวด้านซ้าย (โหมดหลายภาพ)',
              paragraphs: [
                'เมื่อคุณทำงานกับหลายภาพพร้อมกัน — เช่นชุดภาพสินค้า หรือเซสชันพอร์ตเทรตเต็ม — จะมีแถบรูปย่อแนวตั้งปรากฏทางซ้ายสุดของหน้าจอ นี่คือคิวของภาพ แสดงพรีวิวขนาดเล็กของทุกไฟล์ที่โหลด คลิกที่รูปย่อใดๆ เพื่อสลับแคนวาสไปยังภาพนั้นทันที ทำให้คุณตรวจสอบลายน้ำในองค์ประกอบที่แตกต่างได้โดยไม่เสียการตั้งค่าเลเยอร์',
                'แถบนี้ยังแสดงขนาดไฟล์เป็น KB หรือ MB พร้อมแท็กฟอร์แมต (JPG, PNG, WEBP) เพื่อให้คุณรู้ว่าแต่ละไฟล์คืออะไรได้ในทันที',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-steps',
          tocLabel: 'ทีละขั้นตอน',
          title: 'ทีละขั้นตอน: วิธีใส่ลายน้ำบน Photremium',
          paragraphs: [
            'คู่มือนี้อ้างอิงจากการทำงานจริงของเครื่องมือ — ตั้งแต่ระบบอัปโหลดแบบลากวางไปจนถึงเอนจินเรนเดอร์บนแคนวาสที่เขียนลายน้ำลงบนภาพอย่างถาวรก่อนดาวน์โหลด',
          ],
          steps: [
            {
              heading: 'ขั้นตอนที่ 1 — อัปโหลดรูปภาพของคุณ',
              paragraphsBefore: [
                'ไปที่ photremium.com/watermark-image คุณจะเข้าสู่หน้าจออัปโหลดที่มีพื้นที่ลากวางตรงกลางหน้า',
                'คุณมีสามวิธีในการนำรูปภาพเข้าเครื่องมือ:',
              ],
              bullets: [
                'Drag and drop. ลากรูปภาพหนึ่งหรือหลายไฟล์จากเดสก์ท็อปลงในพื้นที่ลากวาง เครื่องมือรองรับฟอร์แมตรูปภาพมาตรฐานทั้งหมด — JPEG, PNG, WEBP และอื่นๆ เมื่อคุณลากไฟล์เข้ามา จะมีขอบสีม่วงพร้อมข้อความ “Drop images to add for watermarking” แสดงว่ารับไฟล์แล้ว',
                'Click to browse. คลิกปุ่ม “Choose Files” ภายในพื้นที่ลากวางเพื่อเปิดตัวเลือกไฟล์ คุณสามารถเลือกหลายไฟล์พร้อมกันด้วย Ctrl+Click (Windows) หรือ Cmd+Click (Mac)',
                'Paste from clipboard. หากคุณคัดลอกรูปภาพไว้ในคลิปบอร์ด — จากภาพหน้าจอ แอปอื่น หรือเบราว์เซอร์ — เพียงกด Ctrl+V (หรือ Cmd+V บน Mac) ที่หน้าลายน้ำ ภาพจะโหลดเข้าสู่พื้นที่ทำงานทันที วิธีนี้ใช้ได้แม้มีหลายรูปโหลดอยู่แล้ว',
              ],
              paragraphsAfter: [
                'เมื่อรูปแรกโหลดเสร็จ พื้นที่ทำงานจะเปลี่ยนจากหน้าจออัปโหลดไปเป็นตัวแก้ไขสามแผงเต็มรูปแบบ และแคนวาสจะแสดงรูปของคุณด้วยระดับซูม fit-to-screen ที่คำนวณอัตโนมัติ',
              ],
            },
            {
              heading: 'ขั้นตอนที่ 2 — เพิ่มเลเยอร์ลายน้ำแบบข้อความ',
              paragraphsBefore: [
                'คลิกปุ่มสีม่วง “Add Text” ในแผงด้านขวา เลเยอร์ข้อความใหม่จะปรากฏบนแคนวาสพร้อมข้อความตัวอย่าง “Type here...” ที่ถูกเลือกอยู่',
                'คุณสามารถพิมพ์ได้ทันที ข้อความจะแสดงแบบเรียลไทม์บนแคนวาสด้วย Arial สีขาวและขนาดเริ่มต้นที่เหมาะกับภาพ จากแถบเครื่องมือด้านบนที่ปรากฏเมื่อเลือกเลเยอร์ข้อความ คุณสามารถปรับแต่งทุกส่วนของข้อความได้:',
              ],
              bullets: [
                'Font family — เลือกจากฟอนต์ในตัว 12 แบบ เช่น Arial, Georgia, Impact, Brush Script MT, Comic Sans MS เป็นต้น',
                'Font size — พิมพ์ค่าพิกเซลเองหรือใช้ปุ่มเพิ่ม/ลด',
                'Bold, italic, underline — เปิดใช้การจัดสไตล์ได้ตามต้องการ',
                'Text color — คลิกสีเพื่อเปิดตัวเลือกสีและเลือกสีแบบ hex ได้',
                'Background color — เพิ่มพื้นหลังสีหลังข้อความเพื่อให้ดูเหมือนป้ายหรือแบดจ์',
                'Stroke (outline) — ตั้งค่าความหนาและสีเส้นขอบเพื่อให้มองเห็นได้ชัดบนพื้นหลังสว่าง/มืด',
                'Opacity — เลื่อนจาก 0% (มองไม่เห็น) ถึง 100% (ทึบเต็ม); ลายน้ำส่วนใหญ่อยู่ที่ 30–60%',
                'Alignment — จัดชิดซ้าย กลาง หรือขวาในกรอบข้อความ',
                'Rotation — หมุนเลเยอร์ข้อความได้ทุกมุม พร้อมจุดสแนปที่ 0°, 90°, 180°, 270° เพื่อวางตรงๆ ได้เร็ว',
              ],
              paragraphsAfter: [
                'หากต้องการย้ายข้อความ ให้คลิกแล้วลากไปบนแคนวาส สำหรับการจัดวางแบบพิกเซลเป๊ะ ให้ใช้ปุ่มลูกศรบนคีย์บอร์ด (กด Shift เพื่อเลื่อนไปทีละ 10 พิกเซล) หากต้องการปรับขนาดกรอบข้อความ ให้ลากจากจุดจับทั้งแปดจุด (มุมและด้าน) ที่อยู่รอบเลเยอร์ที่เลือก',
              ],
            },
            {
              heading: 'ขั้นตอนที่ 3 — เพิ่มเลเยอร์ลายน้ำแบบรูปภาพ (โลโก้)',
              paragraphsBefore: [
                'หากต้องการใช้โลโก้ ลายเซ็น หรือรูปภาพเป็นลายน้ำแทน — หรือร่วมกับ — ข้อความ ให้คลิกปุ่มสีฟ้า “Add Image” ในแผงด้านขวา จากนั้นเลือกไฟล์ภาพลายน้ำจากอุปกรณ์ของคุณ',
                'เครื่องมือจะปรับขนาดภาพลายน้ำอัตโนมัติให้กว้างประมาณ 30% ของแคนวาส โดยรักษาอัตราส่วนเดิม และวางไว้ตรงกลางแคนวาส จากนั้นคุณสามารถลากไปวางตำแหน่งใดก็ได้ ปรับขนาดด้วยจุดจับมุม (ล็อกสัดส่วน) หรือหมุนด้วยจุดหมุนเฉพาะที่อยู่เหนือเลเยอร์ที่เลือก',
                'สำหรับเลเยอร์ลายน้ำแบบรูปภาพ แผงด้านขวาจะมีตัวควบคุมเพิ่มเติม:',
              ],
              bullets: [
                'Opacity — เหมือนเลเยอร์ข้อความ เหมาะสำหรับโลโก้ PNG โปร่งใส',
                'Flip horizontal / Flip vertical — กลับด้านลายน้ำได้หากต้องการ',
                'Border width, border color, and border style — เพิ่มเส้นขอบให้โลโก้ลายน้ำ',
                'Border radius — ทำมุมมนให้โลโก้แบบเท่ากันหรือแยกมุมได้',
                'Rotation — พฤติกรรมการหมุนที่ลื่นไหลเหมือนเลเยอร์ข้อความ',
              ],
            },
            {
              heading: 'ขั้นตอนที่ 4 — ตั้งค่าไทล์ (ตัวเลือก)',
              paragraphsBefore: [
                'หนึ่งในฟีเจอร์ที่ทรงพลังคือไทล์ — ความสามารถในการทำซ้ำลายน้ำทั่วทั้งภาพเป็นลวดลายตาราง เหมาะมากเมื่อคุณต้องการทำให้ภาพใช้งานซ้ำได้ยาก ไม่ใช่แค่ติดแบรนด์',
                'เมื่อเลือกเลเยอร์แล้ว ให้ดูตัวเลือกไทล์บนแถบเครื่องมือ คุณตั้งค่าได้เป็น:',
              ],
              bullets: [
                'None — วางครั้งเดียว (ค่าเริ่มต้น)',
                'Grid 2×2 — ทำซ้ำเป็นรูปแบบ 2 คอลัมน์ 2 แถว',
                'Grid 3×3 — ทำซ้ำเป็นกริด 3×3 เพื่อความหนาแน่นมากขึ้น',
              ],
              paragraphsAfter: [
                'คุณยังสามารถปรับระยะห่างของไทล์ ซึ่งควบคุมช่องว่างระหว่างการทำซ้ำแต่ละครั้ง แคนวาสจะแสดงตัวอย่างเงาของทุกสำเนาเพื่อให้คุณเห็นรูปแบบครอบคลุมทั้งหมดก่อนดาวน์โหลด',
              ],
            },
            {
              heading: 'ขั้นตอนที่ 5 — ใช้ตัวจัดการเลเยอร์สำหรับลายน้ำหลายชั้น',
              paragraphsBefore: [
                'คุณสามารถเพิ่มเลเยอร์ได้ไม่จำกัด — ผสมลายน้ำข้อความและรูปภาพได้ตามต้องการ ตัวจัดการเลเยอร์ในแผงด้านขวาจะแสดงทั้งหมด คุณสามารถ:',
              ],
              bullets: [
                'แสดง/ซ่อนเลเยอร์ด้วยไอคอนตา — ใช้สลับเวอร์ชันลายน้ำได้โดยไม่ต้องลบ',
                'ล็อกเลเยอร์เพื่อป้องกันการขยับโดยไม่ได้ตั้งใจขณะทำงานกับเลเยอร์อื่น',
                'ลบเลเยอร์ถาวร',
              ],
              paragraphsAfter: [
                'คลิกรายการเลเยอร์ใดๆ ในรายการจะเลือกเลเยอร์นั้นบนแคนวาส ทำให้สลับไปมาระหว่างเลเยอร์ได้ง่ายโดยไม่ต้องไล่หาในภาพ',
              ],
            },
            {
              heading: 'ขั้นตอนที่ 6 — สลับระหว่างหลายรูปภาพ',
              paragraphsBefore: [
                'หากคุณอัปโหลดมากกว่าหนึ่งรูป ให้ใช้แถบรูปย่อด้านซ้ายเพื่อสลับภาพที่กำลังแก้ไขบนแคนวาส เลเยอร์ลายน้ำที่คุณตั้งค่าจะถูกใช้กับทุกภาพในชุดเมื่อเอ็กซ์พอร์ต',
                'เครื่องมือยังตรวจสอบความสอดคล้องของความละเอียดในชุดภาพ หากภาพมีขนาดแตกต่างกันมาก (มากกว่า 5% ของความกว้างหรือความสูง) จะมีคำเตือนว่าแหน่งลายน้ำอาจต่างกันเพราะขนาดไม่เท่ากัน เอนจินจะจัดการด้วยอัลกอริทึมจัดตำแหน่งแบบสัดส่วน โดยคำนวณตำแหน่งลายน้ำเป็นเปอร์เซ็นต์จากภาพอ้างอิงและนำสัดส่วนนั้นไปใช้กับภาพอื่นทั้งหมด เพื่อให้คงเจตนาทางภาพแม้ความละเอียดต่างกัน',
              ],
            },
            {
              heading: 'ขั้นตอนที่ 7 — ตั้งค่าการดาวน์โหลด',
              paragraphsBefore: [
                'สำหรับงานภาพเดี่ยว ให้คลิกปุ่ม “Download” ใต้แคนวาสเพื่อบันทึกรูปที่ใส่ลายน้ำโดยตรง ชื่อไฟล์จะถูกตั้งเป็นชื่อเดิมพร้อมเติม “-watermarked” ก่อนนามสกุล ภาพ JPEG จะถูกส่งออกที่คุณภาพ 0.95 — สูงพอจนแทบแยกไม่ออกจากภาพต้นฉบับในขนาดดูปกติ ส่วน PNG จะถูกส่งออกแบบ lossless',
                'สำหรับงานแบบหลายภาพ คุณมีโหมดดาวน์โหลดสองแบบในแผงด้านขวา:',
              ],
              bullets: [
                'ZIP file — รวมรูปที่ใส่ลายน้ำทั้งหมดไว้ในไฟล์ ZIP เดียวแล้วดาวน์โหลดได้ในคลิกเดียว เครื่องมือจะโหลด JSZip แบบไดนามิกเพื่อบีบอัด',
                'Separate files — ดาวน์โหลดแต่ละรูปแยกกัน พร้อมหน่วงเล็กน้อยระหว่างการดาวน์โหลดเพื่อป้องกันการ throttling ของเบราว์เซอร์',
              ],
            },
            {
              heading: 'ขั้นตอนที่ 8 — ดาวน์โหลดและตรวจสอบ',
              paragraphsBefore: [
                'หลังจากคลิกปุ่มดาวน์โหลด (หรือปุ่ม “Watermark & Download All” สำหรับหลายภาพ) เครื่องมือจะเรนเดอร์แต่ละรูปลงบนแคนวาส HTML5 ที่ซ่อนอยู่ด้วยความละเอียดเต็ม — ไม่ใช่ขนาดพรีวิวที่เห็นบนหน้าจอ นั่นหมายความว่าภาพที่ส่งออกจะมีขนาดพิกเซลดั้งเดิม 100% พร้อมลายน้ำที่ถูกวาดในขนาดที่ถูกสัดส่วน เปิดไฟล์ที่ดาวน์โหลดแล้วซูมเข้าเพื่อยืนยันว่าตำแหน่งและคุณภาพลายน้ำตรงตามที่ต้องการ',
                'ถ้าดูยังไม่ดี ให้กลับไปที่พื้นที่ทำงาน — เลเยอร์ของคุณยังอยู่ — ปรับแล้วดาวน์โหลดใหม่ได้ทันที',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-tips',
          tocLabel: 'เคล็ดลับโปร',
          title: 'เคล็ดลับโปรเพื่อผลลัพธ์ที่ดีที่สุด',
          bullets: [
            'ใช้โลโก้ PNG แบบกึ่งโปร่งใสเพื่อความเป็นมืออาชีพสูงสุด ลายน้ำโลโก้ที่มีพื้นหลังโปร่งใสและความทึบ 40–50% จะดูเรียบร้อยกว่าข้อความทึบมาก ควรส่งออกโลโก้จากเครื่องมือออกแบบเป็น PNG ที่มี alpha ก่อนใช้งานเป็นเลเยอร์รูปภาพ',
            'วางลายน้ำในตำแหน่งที่การครอปจะทำให้มูลค่าลดลง มุมล่างขวาเป็นตำแหน่งที่พบได้บ่อย — และครอปออกได้ง่ายที่สุด หากต้องการป้องกันมากขึ้น ให้วางลายน้ำทับบริเวณสำคัญ เช่น ใบหน้า รายละเอียดสินค้า หรือจุดโฟกัส ตัวเลือกไทล์แนวทแยงยิ่งยากต่อการลบโดยไม่ทำให้ภาพเสียหาย',
            'ใช้ฟังก์ชันล็อกเมื่อทำงานกับหลายเลเยอร์ เมื่อพอใจกับตำแหน่งลายน้ำหลักแล้ว ให้ล็อกเลเยอร์นั้นก่อนเพิ่มเลเยอร์รอง เพื่อป้องกันการขยับโดยไม่ตั้งใจ',
            'ทดสอบทั้งพื้นที่สว่างและมืด ลายน้ำสีขาวจะมองไม่เห็นบนท้องฟ้าสว่าง แต่เห็นชัดบนเงามืด เพิ่มเส้นขอบบางๆ หรือพื้นหลังอ่อนๆ เพื่อให้มองเห็นได้ชัดไม่ว่าจะวางทับอะไร',
            'คีย์ลัดช่วยประหยัดเวลาเสมอ ปุ่มลูกศรย้ายเลเยอร์ทีละ 1 พิกเซล Shift+Arrow ย้ายทีละ 10 พิกเซล ปุ่ม Delete ลบเลเยอร์ที่เลือกทันที คีย์ลัดเหล่านี้ทำให้การปรับละเอียดเร็วกว่าการลาก',
          ],
        },
        {
          id: 'wm-blog-privacy',
          tocLabel: 'ความเป็นส่วนตัวและความปลอดภัย',
          title: 'ความเป็นส่วนตัวและความปลอดภัย: ทำไมการประมวลผลในเบราว์เซอร์จึงสำคัญ',
          paragraphs: [
            'ความกังวลทั่วไปของครีเอเตอร์เมื่อใช้เครื่องมือออนไลน์คือ: รูปภาพของฉันไปอยู่ที่ไหน? กับเครื่องมือลายน้ำแบบเซิร์ฟเวอร์ รูปของคุณจะถูกอัปโหลดไปยังเซิร์ฟเวอร์ของผู้ให้บริการ ประมวลผลที่นั่น แล้วส่งกลับมา นั่นหมายความว่างานที่ยังไม่เผยแพร่ รูปลูกค้า หรือภาพสินค้าที่อ่อนไหวจะผ่านโครงสร้างของคนอื่น',
            'เครื่องมือลายน้ำของ Photremium ประมวลผลทุกอย่างในเครื่องผ่านเบราว์เซอร์ ภาพของคุณจะถูกโหลดเข้าสู่หน่วยความจำด้วย File API ของเบราว์เซอร์และไม่ถูกส่งผ่านอินเทอร์เน็ต การเรนเดอร์ลายน้ำทำบนองค์ประกอบ HTML5 canvas ด้วย JavaScript ภายในแท็บเบราว์เซอร์ของคุณทั้งหมด เมื่อคุณปิดหน้าเว็บหรือคลิก “Start Over” ข้อมูลภาพทั้งหมดจะถูกปล่อยจากหน่วยความจำและทิ้งไป ไม่มีอะไรถูกเก็บไว้นอกอุปกรณ์ของคุณ',
          ],
        },
        {
          id: 'wm-blog-summary',
          tocLabel: 'สรุปสุดท้าย',
          title: 'ทำไมเครื่องมือลายน้ำของ Photremium จึงควรมีที่ในเวิร์กโฟลว์ประจำของคุณ',
          paragraphs: [
            'มีเครื่องมือลายน้ำออนไลน์มากมาย สิ่งที่แยกระหว่างเครื่องมือที่ควรเก็บไว้กับเครื่องมือที่ควรลืม มักเป็นการผสมผสานระหว่างความเร็ว การควบคุม และความน่าเชื่อถือ',
            'ความเร็วสำคัญเพราะการใส่ลายน้ำไม่ควรเพิ่มเวลามากให้กับเวิร์กโฟลว์หลังการถ่ายทำ เครื่องมือ Photremium โหลดเร็ว ประมวลผลในเครื่อง และส่งออกที่ความละเอียดเต็มในไม่กี่วินาที — แม้จะเป็นชุดใหญ่ ก็ไม่ต้องรอการประมวลผลจากเซิร์ฟเวอร์ ไม่มีคิว และไม่มีเวลาเรนเดอร์ที่เพิ่มขึ้นตามจำนวนผู้ใช้พร้อมกัน',
            'การควบคุมสำคัญเพราะลายน้ำที่ดูผิดนั้นแย่กว่าการไม่มีลายน้ำ — ทำให้แบรนด์ของคุณดูไม่เป็นมืออาชีพ ระบบเลเยอร์ การควบคุมแบบรายคุณสมบัติ พรีวิวแบบเรียลไทม์ และคีย์ลัด รวมกันเป็นระดับการควบคุมที่เทียบได้กับซอฟต์แวร์เดสก์ท็อปเฉพาะทาง',
            'ความน่าเชื่อถือสำคัญเพราะงานที่ยังไม่เผยแพร่ของคุณมีค่า การรู้ว่ารูปของคุณไม่เคยผ่านอินเทอร์เน็ตไปยังเซิร์ฟเวอร์ของบุคคลที่สาม หมายความว่าคุณสามารถใส่ลายน้ำให้รูปของลูกค้า รูปสินค้าที่ยังไม่เปิดตัว และงานสร้างสรรค์ที่อ่อนไหวได้โดยไม่ต้องกังวลเรื่องการจัดการข้อมูล การรั่วไหลของเซิร์ฟเวอร์ หรือการเปลี่ยนนโยบายของผู้ให้บริการคลาวด์',
            'ไม่ว่าคุณจะเพิ่มคำเตือนลิขสิทธิ์อย่างรวดเร็วให้ภาพเดียว หรือประมวลผลภาพ 200 รูปทั้งชุดก่อนแชร์แกลเลอรีลูกค้า เครื่องมือลายน้ำของ Photremium ให้ทุกอย่างที่คุณต้องใช้เพื่อทำให้ถูกต้อง — ฟรีทั้งหมด เป็นส่วนตัวทั้งหมด และยืดหยุ่นพอให้ลายน้ำดูเหมือนเป็นส่วนหนึ่งของภาพ ไม่ใช่สิ่งที่แปะทับ',
            'ไปที่ photremium.com/watermark-image แล้วลองดู ภาพลายน้ำภาพแรกของคุณอยู่ห่างไปเพียงสามสิบวินาที',
            'Photremium มีชุดเครื่องมือแก้ไขและประมวลผลภาพบนเบราว์เซอร์ ทั้งหมดทำงานในเครื่อง — รูปของคุณจะอยู่บนอุปกรณ์ของคุณเสมอ',
          ],
        },
      ],
    },
  },

  qrGenerator: {
    seo: {
      inputTitle: 'สร้าง QR Code — สร้างและปรับแต่งฟรี | photremium.com',
      inputDesc: 'สร้าง QR Code แบบกำหนดเองสำหรับ URL, ข้อความ, WiFi, ผู้ติดต่อ, อีเมล และ Google Maps',
      inputKeywords: 'สร้าง qr code, สร้าง qr, qr code แบบกำหนดเอง',
      customizeTitle: 'ปรับแต่ง QR Code — photremium.com',
      customizeDesc: 'ปรับแต่งสไตล์ สี กรอบ และโลโก้ของ QR Code ดาวน์โหลดเป็น PNG, JPG, SVG, WEBP หรือ PDF',
      customizeKeywords: 'ปรับแต่ง qr code, สไตล์ qr code',
    },
    title: 'สร้าง QR Code',
    desc: 'สร้าง ปรับแต่ง และดาวน์โหลด QR Code สำหรับ URL, ข้อความ, WiFi, ผู้ติดต่อ, อีเมล และแผนที่',
    generate: 'สร้าง',
    scanQrCode: 'สแกน QR Code',
    tabUrl: 'ลิงก์ / URL',
    tabText: 'ข้อความ',
    tabWifi: 'WiFi',
    tabContact: 'ผู้ติดต่อ',
    tabEmail: 'อีเมล',
    tabMaps: 'Google Maps',
    enterUrl: 'ใส่ URL',
    enterText: 'ใส่ข้อความ',
    networkName: 'ชื่อเครือข่าย (SSID)',
    password: 'รหัสผ่าน',
    encryption: 'การเข้ารหัส',
    hiddenNetwork: 'เครือข่ายที่ซ่อน',
    contactName: 'ชื่อผู้ติดต่อ (ไม่บังคับ)',
    phoneNumber: 'หมายเลขโทรศัพท์',
    emailAddress: 'ที่อยู่อีเมล',
    subject: 'หัวเรื่อง (ไม่บังคับ)',
    body: 'เนื้อหา (ไม่บังคับ)',
    searchLocation: 'ค้นหาตำแหน่ง',
    urlPlaceholder: 'https://example.com',
    textPlaceholder: 'พิมพ์ข้อความที่นี่…',
    wifiNamePlaceholder: 'WiFi ของฉัน',
    passwordPlaceholder: 'รหัสผ่าน',
    contactPlaceholder: 'สมชาย ใจดี',
    phonePlaceholder: '+66 81 234 5678',
    emailPlaceholder: 'example@gmail.com',
    subjectPlaceholder: 'หัวเรื่อง',
    bodyPlaceholder: 'เนื้อหาอีเมล…',
    locationPlaceholder: 'ค้นหาเมือง ที่อยู่ สถานที่…',
    wpaWpa2: 'WPA / WPA2',
    wep: 'WEP',
    none: 'ไม่มี',
    characters: 'ตัวอักษร',
    generateCustomize: 'สร้างและปรับแต่ง',
    editQrData: 'แก้ไขข้อมูล QR',
    styleShape: 'สไตล์และรูปร่าง',
    colorTab: 'สี',
    framesTab: 'กรอบ',
    logoTab: 'โลโก้',
    templatesTab: 'เทมเพลต',
    fileFormatTab: 'รูปแบบไฟล์',
    fgColor: 'สีหน้า',
    bgColor: 'สีพื้นหลัง',
    enableGradient: 'เปิดใช้การไล่สี',
    gradientType: 'ประเภทการไล่สี',
    linear: 'เชิงเส้น',
    radial: 'แบบรัศมี',
    selectFrame: 'เลือกกรอบ',
    selectLogo: 'เลือกโลโก้',
    uploadCustomLogo: 'หรืออัปโหลดโลโก้ของคุณเอง',
    uploadImage: 'อัปโหลดรูปภาพ',
    downloadFormat: 'รูปแบบการดาวน์โหลด',
    preview: 'ดูตัวอย่าง',
    downloadFormatBtn: 'ดาวน์โหลด {format}',
    pngDesc: 'ไม่สูญเสียคุณภาพ รองรับความโปร่งใส',
    jpgDesc: 'รูปแบบไฟล์ยอดนิยม/สากล',
    webpDesc: 'รูปแบบสมัยใหม่ คุณภาพ/ขนาดดีที่สุด',
    svgDesc: 'กราฟิกเวกเตอร์ที่ปรับขนาดได้',
    pdfDesc: 'เอกสารพร้อมพิมพ์',
    lat: 'ละติจูด:',
    lng: 'ลองจิจูด:',
    qrCode: 'QR Code',
    scanMe: 'สแกนฉัน',
    scanHere: 'สแกนที่นี่',
    blog: {
      card1: {
        title: '1. รหัส QR คืออะไร?',
        intro1: 'รูปแบบเต็มของรหัส QR คือ "Quick Response code" (รหัสการตอบสนองอย่างรวดเร็ว) เนื่องจากข้อมูลที่เก็บไว้ในนั้นถูกถอดรหัสได้รวดเร็วมาก จึงเรียกว่า Quick Response (QR) code',
        intro2: 'รหัส QR คือรหัสดิจิทัลสองมิติที่สามารถอ่านได้โดยเครื่องจักรเท่านั้น ข้อมูลในนั้นไม่สามารถอ่านได้โดยมนุษย์ มันมีบล็อคในการจัดเก็บข้อมูลเช่นข้อความ หมายเลขติดต่อ ลิงค์ และสถานที่ Google Maps เป็นต้น',
        inventionTitle: 'วิธีการประดิษฐ์รหัส QR:',
        inventionText: 'รหัส QR ถูกประดิษฐ์ในปี 1994 Masahiro Hara และทีมของเขาทำงานในบริษัทญี่ปุ่นชื่อ Denso Wave ซึ่งผลิตชิ้นส่วนรถยนต์สำหรับ Toyota พวกเขาต้องการรหัสที่จัดเก็บข้อมูลมากกว่าบาร์โค้ดทั่วไป จึงประดิษฐ์รหัส QR',
        keyFeaturesTitle: 'คุณลักษณะหลักของรหัส QR',
        keyFeatures: [
          {
            title: 'วิธีการทำงานของ QR',
            text: 'คุณป้อนข้อความหรือลิงค์เพื่อสร้างรหัส QR สร้างเครื่องกำเนิด QR โครงสร้างกล่องสี่เหลี่ยมตามข้อมูล กล่องแต่ละกล่องแสดงถึงหนึ่งบิต และแต่ละบิตจัดเก็บอักขระหนึ่งตัว',
          },
          {
            title: 'โครงสร้างของรหัส QR',
            text: 'รหัส QR ประกอบด้วยกล่องสี่เหลี่ยมขนาดใหญ่สามกล่องเพื่ออนุมัติทิศทางของรหัส QR และกล่องสี่เหลี่ยมเล็กกล่องเพื่อจัดเก็บบิต (ข้อมูล)',
          },
          {
            title: 'ความจุข้อมูลของรหัส QR',
            text: 'โดยทั่วไปรหัส QR จัดเก็บข้อมูลมากกว่าบาร์โค้ด รหัส QR เป็นเพียงเวอร์ชันที่มีประสิทธิมากขึ้นของบาร์โค้ด โดยพื้นฐานแล้วเป็นบาร์โค้ดสองมิติ รหัส QR จัดเก็บเกือบ 200 อักขระ มันยังสามารถจัดเก็บอักขระ 400 ตัว แต่อาจยากต่อการสแกน การจัดเก็บมากกว่า 400 อักขระอาจส่งผลให้รหัส QR ที่ซับซ้อนมาก ซึ่งแทบไม่สามารถสแกนได้',
          },
          {
            title: 'การตรวจหาข้อผิดพลาดในรหัส QR',
            text: 'รหัส QR สามารถสแกนได้อย่างถูกต้องแม้ว่าข้อมูลบางอย่างจะขูดเกาหรือบิตบางตัวกลับหัว รหัส QR ใช้เทคนิคการตรวจหาข้อผิดพลาด Reed-Solomon เพื่อตรวจหาข้อผิดพลาดและแก้ไขหลังจากการระบุตัวตน',
          },
        ],
        errorTitle: 'ระดับการแก้ไขข้อผิดพลาดของรหัส QR:',
        errorIntro: 'มีการใช้เทคนิคการตรวจหาและแก้ไขข้อผิดพลาดที่แตกต่างกันในกรณีต่างๆ ตามที่อธิบายไว้ด้านล่าง:',
        errorHeaders: {
          level: 'ระดับ',
          recovery: 'ความสามารถในการกู้คืน',
          bestUse: 'กรณีการใช้งานที่ดีที่สุด',
        },
        errorRows: [
          {
            level: 'ต่ำ (L)',
            recovery: '~7%',
            useCases: [
              'เทคนิคการแก้ไขข้อผิดพลาดนี้ใช้เมื่อรหัส QR แสดงบนหน้าจอดิจิทัล เว็บไซต์ หรือในสภาพแวดล้อมที่สะอาด',
              'เมื่อสร้างรหัส QR สำหรับข้อมูลเล็กน้อย เช่น Gmail หมายเลขติดต่อ หรือข้อความเล็ก',
            ],
          },
          {
            level: 'ปานกลาง (M)',
            recovery: '~15%',
            useCases: [
              'สำหรับใบปลิวและโปสเตอร์ที่ติดตั้งในสภาพแวดล้อมที่สะอาด และเมื่อความเสี่ยงในการสึกหรอไม่มีนัยสำคัญ',
            ],
          },
          {
            level: 'ควอร์ไทล์ (Q)',
            recovery: '~25%',
            useCases: [
              'เมื่อรหัส QR ต้องติดตั้งในสภาพแวดล้อมที่หนักหน่วง เช่นในโรงงาน/กลางแจ้ง',
              'นอกจากนี้ เมื่อต้องใช้โลโก้ขนาดเล็กในตรงกลาง มันจะครอบคลุมบิตบางตัว ดังนั้นจึงต้องใช้เทคนิคการแก้ไขข้อผิดพลาดนี้',
            ],
          },
          {
            level: 'สูง (H)',
            recovery: '~30%',
            useCases: [
              'ใช้เมื่อรหัส QR อาจเสียหายหนัก',
              'เมื่อโลโก้ขนาดใหญ่ปกคลุมจุดศูนย์กลางของรหัส QR',
              'นอกจากนี้เมื่อต้องจัดรูปแบบหนักสำหรับรหัส QR',
            ],
          },
        ],
      },
      card2: {
        title: '2. ทำไมต้องเลือกตัวสร้างรหัส QR ของเรา?',
        intro: 'ตัวสร้างรหัส QR ของเราทำให้การสร้างรหัส QR เร็วมาก ปลอดภัย และง่ายดาย คุณสามารถปรับแต่งรหัสของคุณเพื่อให้เป็นขั้นสูง มืออาชีพ และสอดคล้องกับธีมธุรกิจของคุณ การปรับแต่งทั้งหมดตั้งแต่การระบายสีรหัส QR ไปจนถึงการติดตั้งโลโก้ในรหัส QR นั้นให้ไว้ฟรีตลอดไป',
        strengths: [
          {
            title: 'การปรับแต่งแบบมืออาชีพ:',
            text: 'คุณสามารถสร้างและปรับแต่งรหัส QR ได้มากเท่าที่คุณต้องการโดยไม่มีค่าใช้จ่ายใด ๆ คุณลักษณะทั้งหมดเป็นอักษร ฟรี คุณสามารถใช้สีไล่ระดับ รูปร่างต่างๆ สำหรับกล่องสี่เหลี่ยม โลโก้ที่กำหนดเอง และคุณลักษณะอื่น ๆ อีกมากมาย',
          },
          {
            title: 'รองรับรูปแบบหลายรูปแบบ:',
            text: 'ตัวสร้างรหัส QR ของเรามีรูปแบบการดาวน์โหลดหลากหลายเพื่อความสะดวกของคุณ คุณเพียงแค่ต้องเลือกรูปแบบที่คุณต้องการก่อนดาวน์โหลด ปัจจุบันเรามีรูปแบบเหล่านี้:',
          },
          {
            title: 'แม่แบบที่ทำไว้ล่วงหน้า:',
            text: 'คุณสามารถใช้สีไล่ระดับที่ทำเตรียมไว้และเฟรมที่ทำให้รหัส QR ของคุณเป็นมืออาชีพ',
          },
          {
            title: 'รองรับโลโก้ที่กำหนดเอง:',
            text: 'คุณยังสามารถอัพโหลดโลโก้ยี่ห้อที่กำหนดเองของคุณซึ่งเข้ากันโดยอัตโนมัติในตรงกลางของรหัส QR คุณยังสามารถเลือกโลโก้จากไลบรารีโลโก้ในตัวซึ่งให้โลโก้มากกว่า 30 รายการ',
          },
          {
            title: 'ตัวอย่างสด:',
            text: 'ขณะที่คุณปรับแต่ง คุณสามารถดูการเปลี่ยนแปลงทั้งหมดในแผงตัวอย่างสด การเปลี่ยนแปลงเหล่านี้ในแผงตัวอย่างเป็นแบบเรียลไทม์ที่เปลี่ยนแปลงแบบไดนามิก',
          },
          {
            title: 'ตัวบ่งชี้การสแกน:',
            text: 'เมื่อเลือกสี ตัวเตือนและตัวบ่งชี้ที่เหมาะสมจะแนะนำคุณหากคุณเลือกสีที่ยากต่อการสแกน',
          },
        ],
        formatHeaders: {
          srNo: 'ลำดับ',
          formats: 'รูปแบบ',
          description: 'คำอธิบาย',
        },
        formatRows: [
          { no: '1', format: 'PNG', description: 'ไม่มีการสูญเสีย รองรับความโปร่งใส' },
          { no: '2', format: 'JPG', description: 'รูปแบบไฟล์ยอดนิยม/สากล' },
          { no: '3', format: 'WEBP', description: 'รูปแบบสมัยใหม่ คุณภาพ/ขนาดที่ดีที่สุด' },
          { no: '4', format: 'SVG', description: 'กราฟิกเวกเตอร์ที่ปรับขนาดได้' },
          { no: '5', format: 'PDF', description: 'เอกสารพร้อมพิมพ์' },
        ],
      },
      card3: {
        title: '3. คำแนะนำทีละขั้นตอน:',
        step1Intro: 'ก่อนอื่นต้องเลือกหมวดหมู่ของรหัส QR ที่คุณต้องการสร้าง ไม่ว่าคุณจะสร้างรหัส QR สำหรับติดต่อ แผนที่ ลิงค์ หรือข้อความ ปัจจุบันตัวสร้างรหัส QR ของเรามีหมวดหมู่เหล่านี้:',
        categories: ['ลิงค์ / URL', 'ข้อความ', 'WiFi', 'ติดต่อ', 'Gmail', 'Google Maps'],
        step2: 'หลังจากเลือกหมวดหมู่ให้วางข้อมูลของคุณในช่องข้อความตามนั้น',
        step3Intro: 'จากนั้นคลิกที่ "สร้างและปรับแต่ง" เพื่อเปิดแผงปรับแต่ง ในแผงปรับแต่ง คุณจะเห็นแถบนำทางย่อยพร้อมตัวเลือกต่อไปนี้:',
        options: [
          {
            title: 'สไตล์และรูปร่าง:',
            text: 'ในส่วนนี้ คุณสามารถเปลี่ยนรูปร่างของกล่องสี่เหลี่ยมเป็นหลายสไตล์ เช่น มุมมน จุด แถบแนวนอน แถบแนวตั้ง สี่เหลี่ยมเล็ก และอื่นๆ อีกมากมาย',
          },
          {
            title: 'สี:',
            text: 'คุณสามารถเลือกสีพื้นหลังและสีแบบกำหนดเองในส่วนนี้ เพื่อให้รหัส QR ของคุณอยู่ในสีไล่ระดับ คุณมีตัวเลือกในการเปิดใช้งานไล่ระดับซึ่งให้คุณใช้สีไล่ระดับใดๆ จากไลบรารีในตัว หรือสร้างสีไล่ระดับของคุณเองได้อย่างง่ายดาย คุณยังสามารถเปลี่ยนมุมสำหรับสีไล่ระดับเชิงเส้นได้ รองรับไล่ระดับเรเดียลด้วย คุณสามารถเพิ่มสีหลายสีเพื่อสร้างเอฟเฟกต์ไล่ระดับแบบมืออาชีพ',
          },
          {
            title: 'เฟรม:',
            text: 'ที่นี่คุณสามารถเลือกเฟรมที่สมบูรณ์แบบสำหรับรหัส QR ของคุณ เฟรมทั้งหมดจะเข้ากันอย่างอัตโนมัติกับรหัสของคุณ คุณเพียงแค่ต้องเลือกเฟรมจากไลบรารีในตัว',
          },
          {
            title: 'โลโก้:',
            text: 'หลังจากเลือกเฟรมแล้ว คุณสามารถเลือกโลโก้ที่ปรับตัวโดยอัตโนมัติตรงกลางของรหัส QR การอัพโหลดโลโก้ยี่ห้อที่กำหนดเองของคุณก็ได้รับการสนับสนุนเช่นกัน',
          },
          {
            title: 'แม่แบบ:',
            text: 'หากคุณไม่ต้องการเลือกสไตล์ รูปร่าง สี และเฟรมแยกกัน คุณสามารถใช้แม่แบบที่ทำไว้ล่วงหน้ากับรหัส QR ของคุณ แม่แบบพรีเมียมหลายรายการพร้อมใช้งานเพื่อความสะดวกของคุณซึ่งปลอดภัยตลอดไป',
          },
          {
            title: 'รูปแบบไฟล์:',
            text: 'สุดท้ายคุณต้องเลือกประเภทไฟล์ที่คุณต้องการดาวน์โหลดรหัส QR รองรับรูปแบบทั่วไปหลายรูปแบบ รวมถึง PNG, WEBP, SVG และ PDF เป็นต้น',
          },
          {
            title: 'แก้ไขข้อมูล QR:',
            text: 'คุณยังสามารถแก้ไขข้อมูล QR ของคุณโดยไม่สูญเสียใดๆ ในการปรับแต่งที่เลือกของคุณ',
          },
        ],
        finalStep: 'จากนั้นเพียงแค่คลิกปุ่มดาวน์โหลด และรหัส QR ตามการปรับแต่งของคุณตรงตามรูปแบบที่เลือกจะดาวน์โหลดทันทีโดยไม่มีค่าใช้จ่ายใด ๆ',
      },
      card4: {
        title: '4. ประโยชน์:',
        intro: 'รหัส QR เชื่อมโยงโลกทางกายภาพกับประสบการณ์ดิจิทัล เป็นวิธีที่เร็วที่สุดในการแบ่งปันลิงค์ ติดต่อ หรือสถานที่ของคุณ คุณเพียงแค่ต้องสแกนรหัส QR เพื่อเข้าถึงข้อมูลทันที ดังนั้นจึงได้รับความนิยมมากในธุรกิจและโลกดิจิทัลเนื่องจากประสิทธิภาพของเวลาและจุดประสงค์สูง',
        benefits: [
          {
            title: 'การสนับสนุนตลอดชีวิต:',
            text: 'รหัส QR ทำงานตลอดไปโดยไม่มีวันหมดอายุ พวกเขามอบข้อมูลที่จัดเก็บไว้ให้คุณทันทีเมื่อคุณสแกน เนื่องจากเก็บคำแนะนำดิจิทัลที่เข้ารหัสไว้ จึงไม่เคยสูญเสียข้อมูล',
          },
          {
            title: 'การสนับสนุนแบบออฟไลน์:',
            text: 'คุณสามารถสแกนรหัส QR แม้ว่าคุณจะออฟไลน์ก็ได้ กล้องมือถือของคุณจะถอดรหัสรูปแบบของรหัส QR และมอบข้อมูลที่เก็บไว้ให้คุณ',
          },
          {
            title: 'ต้นทุนเป็นศูนย์:',
            text: 'เนื่องจากรหัสเหล่านี้ไม่ต้องการการเปลี่ยนเส้นทางของเซิร์ฟเวอร์หรือทรัพยากร จึงปลอดภัยตลอดไป',
          },
        ],
      },
    },
  },

  qrScanner: {
    seo: {
      title: 'สแกน QR Code — สแกน QR Code จากกล้องหรือรูปภาพ | photremium.com',
      desc: 'สแกน QR Code ทันทีด้วยกล้องหรืออัปโหลดรูปภาพ ตรวจจับ URL, ข้อความ, WiFi, ผู้ติดต่อ และอื่นๆ',
      keywords: 'สแกน qr code, สแกน qr, อ่าน qr, qr code ออนไลน์',
    },
    title: 'สแกน QR Code',
    desc: 'สแกน QR Code ทันทีด้วยกล้องหรืออัปโหลดรูปภาพ รวดเร็วและปลอดภัย',
    generateQrCode: 'สร้าง QR Code',
    scan: 'สแกน',
    cameraScanner: 'สแกนด้วยกล้อง',
    uploadImage: 'อัปโหลดรูปภาพ',
    pointCamera: 'ชี้กล้องไปที่ QR Code',
    startCamera: 'เปิดกล้อง',
    loading: 'กำลังโหลด…',
    dropQrImage: 'วางรูปภาพ QR Code ที่นี่',
    toScan: 'เพื่อสแกน',
    supportedFormats: 'รองรับ JPG, PNG, GIF, WEBP',
    ctrlVPaste: 'วางด้วย Ctrl+V',
    scanFromGallery: 'สแกนจากแกลเลอรี',
    instantScanning: 'สแกนทันที',
    instantScanningDesc: 'ตรวจจับคิวอาร์โค้ดแบบเรียลไทม์จากกล้องหรือรูปภาพที่อัปโหลด',
    private100: 'เป็นส่วนตัว 100%',
    private100Desc: 'การประมวลผลทั้งหมดเกิดขึ้นในเบราว์เซอร์ของคุณ ไม่มีการอัปโหลดข้อมูล',
    multiFormat: 'หลายรูปแบบ',
    multiFormatDesc: 'ตรวจจับ URL, ข้อความ, WiFi, รายชื่อผู้ติดต่อ, อีเมล, โทรศัพท์ และอื่น ๆ',
    accessingCamera: 'กำลังเข้าถึงกล้อง…',
    cameraDenied: 'ถูกปฏิเสธการเข้าถึงกล้อง กรุณาอนุญาตการใช้งานกล้องแล้วลองใหม่',
    noCamera: 'ไม่พบกล้องในอุปกรณ์นี้',
    cameraError: 'ไม่สามารถเข้าถึงกล้องได้ ลองใหม่อีกครั้ง',
    videoError: 'ไม่สามารถเริ่มเล่นวิดีโอได้',
    switchError: 'ไม่สามารถสลับกล้องได้',
    tryAgain: 'ลองอีกครั้ง',
    switchCamera: 'เปลี่ยนกล้อง',
    stop: 'หยุด',
    noQrFound: 'ไม่พบ QR Code',
    couldNotRead: 'ไม่สามารถอ่านรูปภาพได้',
    scannerFailed: 'โหลดสแกนเนอร์ล้มเหลว',
    noQrFoundDesc: 'ไม่พบ QR Code ในรูปภาพ ลองรูปภาพอื่นหรือใช้สแกนเนอร์กล้อง',
    qrScanned: 'สแกน QR Code แล้ว!',
    openLink: 'เปิดลิงก์',
    copied: 'คัดลอกแล้ว!',
    copy: 'คัดลอก',
    share: 'แบ่งปัน',
    scanAgain: 'สแกนอีกครั้ง',
    network: 'เครือข่าย',
    password: 'รหัสผ่าน',
    security: 'ความปลอดภัย',
    unknown: 'ไม่ทราบ',
    typeText: 'ข้อความ',
    typeUrl: 'URL',
    typeWifi: 'เครือข่าย WiFi',
    typeContact: 'บัตรผู้ติดต่อ',
    typeEmail: 'อีเมล',
    typePhone: 'หมายเลขโทรศัพท์',
    typeSms: 'SMS',
    typeLocation: 'ตำแหน่ง',
    blog: {
      tocTitle: 'สารบัญ',
      sections: [
        {
          id: 'why-use-qr-code-scanner',
          title: '1. ทำไมต้องใช้เครื่องสแกนคิวอาร์โค้ด?',
          paragraphs: [
            'เครื่องสแกนคิวอาร์โค้ดโดยพื้นฐานคือกล้องมือถือที่ถอดรหัสข้อมูลที่เก็บอยู่ในคิวอาร์โค้ด คุณเพียงแค่หันกล้องไปที่คิวอาร์โค้ด ไม่ว่าจะวางคิวอาร์โค้ดในทิศทางไหน ระบบก็จะอ่านรูปแบบเฉพาะ ตรวจจับข้อผิดพลาด แก้ไขข้อผิดพลาดหากจำเป็น และแสดงข้อมูลที่อยู่ภายใน',
          ],
          listTitle: 'ประเภทของเครื่องสแกนคิวอาร์โค้ด:',
          bullets: [
            'เครื่องสแกนคิวอาร์โค้ดแบบเว็บ: คุณสามารถสแกนคิวอาร์โค้ดด้วยสแกนเนอร์ออนไลน์ที่เบราว์เซอร์ของคุณรองรับ คุณเข้าถึงข้อมูลได้ผ่านกล้องหรือสแกนโดยอัปโหลดรูปภาพ สำหรับการเปลี่ยนเส้นทางอัตโนมัติและฟีเจอร์ขั้นสูงอื่น ๆ คุณสามารถไปที่ https://photremium.com',
            'กล้องมือถือ: มือถือรุ่นใหม่บางรุ่นมีเครื่องสแกนคิวอาร์โค้ดในแอปกล้องดั้งเดิมอยู่แล้ว สามารถดึงและถอดรหัสข้อมูลได้เพียงสแกนคิวอาร์โค้ดด้วยกล้องปกติ',
            'แอป: มีแอปบางตัวที่สร้างมาเพื่อสแกนคิวอาร์โค้ดโดยเฉพาะ อย่างไรก็ตาม สำหรับการเปลี่ยนเส้นทางขั้นสูงและฟีเจอร์อื่น ๆ อีกมากมาย คุณสามารถติดตั้งแอปผ่านลิงก์นี้ได้ฟรี: https://photremium.com',
            'อุปกรณ์ฮาร์ดแวร์: ยังมีอุปกรณ์ฮาร์ดแวร์ที่ถูกสร้างมาสำหรับสแกนคิวอาร์โค้ดด้วย อุปกรณ์เหล่านี้ถูกใช้กันอย่างแพร่หลายในห้างสรรพสินค้าขนาดใหญ่สำหรับการคิดเงินสินค้า',
          ],
        },
        {
          id: 'why-choose-our-qr-code-scanner',
          title: '2. ทำไมต้องเลือกเครื่องสแกนคิวอาร์โค้ดของเรา?',
          paragraphs: [
            'คุณสามารถสำรวจฟีเจอร์ขั้นสูงหลายอย่าง ตั้งแต่การเปลี่ยนเส้นทางไปจนถึงการคัดลอกเนื้อหาที่ถอดรหัสจากคิวอาร์โค้ด คุณยังสามารถดูฟีเจอร์ที่น่าสนใจอีกมากมายในเครื่องสแกนคิวอาร์โค้ดของเรา เช่น:',
          ],
          bullets: [
            'ความเร็วสูง: เครื่องสแกนคิวอาร์โค้ดของเราทำให้การถอดรหัสคิวอาร์โค้ดรวดเร็วมาก คุณเพียงแค่สแกนคิวอาร์โค้ด และเครื่องมือของเราจะให้ข้อมูลทันที พร้อมตัวเลือกขั้นสูงในการคัดลอกข้อความ/ลิงก์ เปิดหากตรวจพบลิงก์ หรือบันทึกอัตโนมัติหากตรวจพบข้อมูลผู้ติดต่อ',
            'ไม่ต้องติดตั้ง: คุณไม่ต้องติดตั้งแอปแยกเพื่อใช้งานเครื่องสแกนคิวอาร์โค้ดของเรา คุณสามารถเข้าถึงเครื่องมือนี้ได้ฟรีผ่านเบราว์เซอร์ของคุณ',
            'เข้าถึงได้ทุกแพลตฟอร์ม: คุณสามารถใช้งานได้บนทุกอุปกรณ์ ไม่ต้องกังวลเรื่องเวอร์ชันระบบปฏิบัติการหรือข้อกำหนดอื่น ๆ รองรับทุกเวอร์ชันและทุกอุปกรณ์',
            'รองรับทุกฟอร์แมต: รูปแบบข้อมูลทั้งหมดที่สามารถเก็บในคิวอาร์โค้ดได้ เช่น ข้อความธรรมดา, WiFi, URL, รายชื่อผู้ติดต่อ, Gmail และ Google Maps เป็นต้น รองรับโดยเครื่องมือของเรา',
          ],
        },
        {
          id: 'step-by-step-guide',
          title: '3. คู่มือทีละขั้นตอน:',
          steps: [
            {
              heading: '1. ก่อนอื่นให้เลือกวิธีสแกนคิวอาร์โค้ด มี 2 วิธีดังต่อไปนี้:',
              subSteps: [
                {
                  heading: 'i. วิธีใช้กล้อง',
                  paragraphs: [
                    'คุณสามารถสแกนคิวอาร์โค้ดด้วยกล้องของอุปกรณ์ได้ แม้คุณจะใช้แล็ปท็อป พีซี หรืออุปกรณ์ใดก็ตามที่รองรับกล้องทั่วไป เพียงคลิกปุ่ม “Start Camera” ก็จะมีคำขอสิทธิ์ปรากฏขึ้น ให้อนุญาตสิทธิ์เพื่อให้เว็บไซต์นี้ใช้กล้องสำหรับสแกนคิวอาร์โค้ด หากคุณเผลอปฏิเสธไป หรือคำขอสิทธิ์ไม่แสดง คุณสามารถอนุญาตกล้องด้วยตนเองตามขั้นตอนต่อไปนี้:',
                  ],
                  notes: [
                    '➔ สำหรับ Chrome (Android / Desktop):',
                    '1. คลิกจุดสามจุด',
                    '2. ไปที่ Settings',
                    '3. (ข้ามขั้นตอนนี้สำหรับ Android) Privacy and Security',
                    '4. คลิก Site Settings',
                    '5. จากนั้นในส่วน permissions ให้คลิก Camera',
                    '6. หา URL ของเว็บไซต์เรา https://photremium.com/qr-code-scanner',
                    '7. อนุญาตกล้องจากเมนูแบบเลื่อนลง',
                    '➔ สำหรับ Safari (iPhone / iOS):',
                    '1. แตะไอคอน AA หรือ Website Settings ในแถบที่อยู่',
                    '2. เลือก Website Settings',
                    '3. แตะ Camera แล้วเลือก Allow',
                    '4. หากยังถูกบล็อก: ไปที่ iPhone Settings > Safari > Camera แล้วตั้งเป็น Ask หรือ Allow',
                  ],
                },
                {
                  heading: 'ii. วิธีใช้แกลเลอรี',
                  paragraphs: [
                    'คุณสามารถอัปโหลดรูปภาพคิวอาร์โค้ดเพื่อเข้าถึงข้อมูลได้ คลิกปุ่ม “Scan from Gallery” แล้วระบบจะเปิดตัวสำรวจไฟล์ จากนั้นเลือกภาพคิวอาร์โค้ด รองรับไฟล์ภาพทุกประเภท เช่น jpg, .jpeg, .png, .gif, .webp, .svg, .avif, .heic, .heif, .jxl, .bmp, .ico, .tiff, .tif, .jfif, .jpe, .pjpeg, .pjp, .apng, .svgz และ .xbm เป็นต้น',
                  ],
                },
              ],
            },
            {
              heading: '2. เมื่อคุณเลือกคิวอาร์โค้ดแล้ว ข้อมูลทั้งหมดจะแสดงขึ้นมา ทำให้คุณคัดลอก แชร์ หรือเปิดลิงก์ได้หากตรวจพบ และคุณยังสามารถสแกนอีกครั้งได้หากต้องการ',
            },
          ],
        },
        {
          id: 'benefits-of-qr-code-scanner',
          title: 'ประโยชน์ของเครื่องสแกนคิวอาร์โค้ด:.',
          paragraphs: [
            'เครื่องสแกนคิวอาร์โค้ดมีประโยชน์หลายอย่างในโลกดิจิทัลนี้ ช่วยให้การชำระเงิน การยืนยัน และการเข้าถึงข้อมูลง่ายและรวดเร็ว แม้อยู่ในโหมดออฟไลน์',
          ],
          bullets: [
            'เข้าถึงข้อมูลได้ทันที: การสแกนคิวอาร์โค้ดจะให้ข้อมูลภายในเวลาไม่กี่มิลลิวินาที ระบบถอดรหัสรูปแบบ ตรวจจับข้อผิดพลาด และแก้ไขได้อย่างรวดเร็ว มอบประสบการณ์ที่เร็วมากให้ผู้ใช้',
            'การสื่อสารไร้รอยต่อ: ในยุคที่ก้าวหน้าเช่นนี้ มีความจำเป็นอย่างมากต่อการสื่อสารที่รวดเร็วและปลอดภัยสำหรับข้อมูลขนาดเล็ก เช่น รายละเอียดธนาคารและรายละเอียดสินค้า เป็นต้น เครื่องสแกนคิวอาร์โค้ดช่วยแก้ปัญหานี้ เพราะการชำระเงินทำได้ด้วยการสแกนคิวอาร์โค้ด อีกทั้ง Google ยังยืนยันโทรศัพท์มือถือผ่าน QR เมื่อสร้างบัญชีใหม่บนแล็ปท็อป',
            'ตั๋วอิเล็กทรอนิกส์: ที่สถานีรถโดยสาร สถานีรถไฟ หรือสนามบิน คุณสามารถยืนยันตั๋วได้ง่ายโดยไม่ต้องรอคิวนาน นอกจากนี้ยังมีการติดตั้งเครื่องสแกนคิวอาร์โค้ดหลายจุดในสนามบินเพื่อลดการรอคิว สิ่งนี้ยังช่วยลดความต้องการพนักงาน และประหยัดงบประมาณสายการบินโดยอัตโนมัติ',
            'การยืนยันของแท้สินค้า: แบรนด์ขั้นสูงและระดับพรีเมียมจะติดตั้งคิวอาร์โค้ดบนสินค้า ลูกค้าสามารถสแกนคิวอาร์โค้ดนั้นเพื่อตรวจสอบความแท้ของสินค้าได้ว่าเป็นของแท้หรือไม่',
          ],
        },
      ],
    },
  },

  faceBlur: {
    seo: {
      uploadTitle: 'เครื่องมือเบลอใบหน้า — เบลอใบหน้าในรูปภาพออนไลน์ | photremium.com',
      uploadDesc: 'เบลอใบหน้าในรูปภาพอัตโนมัติด้วย AI เลือกความเข้ม รูปร่าง หรืออีโมจิ',
      uploadKeywords: 'เบลอใบหน้า, เบลอหน้า, ตรวจจับใบหน้า, เครื่องมือความเป็นส่วนตัว',
      workspaceTitle: 'เครื่องมือเบลอใบหน้า — photremium.com',
      workspaceDesc: 'เบลอใบหน้าในรูปภาพอัตโนมัติ ฟรี 100%',
      workspaceKeywords: 'เบลอใบหน้า, ตรวจจับใบหน้า',
    },
    title: 'เบลอใบหน้า',
    desc: 'ตรวจจับและเบลอใบหน้าในรูปภาพอัตโนมัติเพื่อปกป้องความเป็นส่วนตัว',
    toBlurFaces: 'เพื่อเบลอใบหน้า',
    autoDetection: 'ตรวจจับอัตโนมัติ',
    autoDetectionDesc: 'AI ตรวจจับใบหน้าทันทีทุกใบหน้า',
    customBlur: 'เบลอแบบกำหนดเอง',
    customBlurDesc: 'ปรับความเข้ม รูปร่าง และสไตล์การเบลอ',
    private100: 'ส่วนตัว 100%',
    private100Desc: 'ประมวลผลทั้งหมดในเบราว์เซอร์',
    blurTools: 'เครื่องมือเบลอ',
    faces: 'ใบหน้า',
    faceDetection: 'การตรวจจับใบหน้า',
    detecting: 'กำลังตรวจจับ...',
    autoDetectFaces: 'ตรวจจับใบหน้าอัตโนมัติ',
    exitManualMode: 'ออกจากโหมดแมนวล',
    manualSelect: 'เลือกแมนวล',
    nFaceRegions: 'พบ {n} บริเวณใบหน้า',
    noFacesDetected: 'ไม่พบใบหน้า — ใช้โหมดแมนวล',
    manualHint: 'คลิกและลากเพื่อวาดสี่เหลี่ยมบนบริเวณที่ต้องการเบลอ',
    blurType: 'ประเภทการเบลอ',
    blur: 'เบลอ',
    emoji: 'อีโมจิ',
    blurIntensity: 'ความเข้มการเบลอ',
    strength: 'ความแรง',
    blurShape: 'รูปร่างการเบลอ',
    rectangle: 'สี่เหลี่ยม',
    ellipse: 'วงรี',
    circle: 'วงกลม',
    chooseEmoji: 'เลือกอีโมจิ',
    blurRegionsN: 'บริเวณเบลอ ({n})',
    faceN: 'ใบหน้า {n}',
    manualRegionN: 'บริเวณแมนวล {n}',
    manualN: 'แมนวล {n}',
    clearAllRegions: 'ล้างทุกบริเวณ',
    processingDots: 'กำลังประมวลผล...',
    downloadBlurred: 'ดาวน์โหลดรูปภาพที่เบลอแล้ว',
    downloadNImages: 'ดาวน์โหลด {n} รูปภาพ',
    downloadDialogTitle: 'ยังไม่ได้แก้ไขทุกรูปภาพ',
    downloadDialogText: 'แก้ไขแล้ว {edited} จาก {total} รูปภาพ',
    downloadAll: 'ดาวน์โหลดทั้งหมด',
    removeRegion: 'ลบบริเวณ',
    region: 'บริเวณ',
    notAllEdited: 'ยังไม่ได้แก้ไขทุกรูปภาพ',
    editedXofY: 'แก้ไขแล้ว {edited} จาก {total}',
    nextImage: 'รูปภาพถัดไป',
  },

  faqData: {
    imageConverter: [
      { q: 'รูปแบบรูปภาพใดบ้างที่รองรับการแปลง?', a: 'เรารองรับ JPG, PNG, WEBP, SVG, GIF, BMP, ICO และ TIFF คุณสามารถแปลงระหว่างรูปแบบเหล่านี้ได้ทันทีในเบราว์เซอร์' },
      { q: 'คุณภาพรูปภาพจะถูกรักษาไว้ระหว่างการแปลงหรือไม่?', a: 'สำหรับรูปแบบไม่สูญเสียข้อมูลเช่น PNG คุณภาพจะถูกรักษาไว้อย่างสมบูรณ์ สำหรับรูปแบบสูญเสียข้อมูลเช่น JPG และ WEBP เราใช้การตั้งค่าการเข้ารหัสที่ปรับให้เหมาะสม' },
      { q: 'มีข้อจำกัดด้านขนาดหรือจำนวนไฟล์หรือไม่?', a: 'ไม่มีข้อจำกัดที่เข้มงวด คุณสามารถอัปโหลดรูปภาพหลายรูปพร้อมกันและแปลงเป็นชุด' },
      { q: 'ข้อมูลของฉันปลอดภัยหรือไม่? รูปภาพถูกส่งไปยังเซิร์ฟเวอร์หรือไม่?', a: 'แน่นอน การประมวลผลทั้งหมดจะเกิดขึ้นในเบราว์เซอร์ของคุณ รูปภาพของคุณไม่เคยออกจากอุปกรณ์' },
      { q: 'ฉันสามารถแปลง PNG ที่โปร่งใสเป็น JPG ได้หรือไม่?', a: 'ได้ เนื่องจาก JPG ไม่รองรับความโปร่งใส บริเวณที่โปร่งใสจะถูกเติมด้วยพื้นหลังสีขาวโดยค่าเริ่มต้น' },
    ],
    imageCompressor: [
      { q: 'การบีบอัดรูปภาพจะทำให้คุณภาพลดลงหรือไม่?', a: 'โดยทั่วไปไม่ลดลง หากคุณไม่บีบอัดเกินช่วงที่แนะนำ ระบบมีตัวบอกคุณภาพให้ดูได้ชัดเจน: i. บีบอัด 1% ถึง 40%: จะแสดงสัญลักษณ์สีเขียวพร้อมข้อความ “คุณภาพดี”. ii. บีบอัด 41% ถึง 60%: จะแสดงสัญลักษณ์สีเหลืองพร้อมข้อความ “คุณภาพปกติ” ซึ่งเป็นช่วงที่แนะนำ. iii. บีบอัด 61% ถึง 100%: ระบบจะแสดงคำเตือนสีแดง “คุณภาพต่ำ” ซึ่งช่วงนี้อาจเห็นคุณภาพลดลงได้ชัดเจน.' },
      { q: 'รองรับรูปแบบไฟล์ใดบ้างสำหรับการบีบอัด?', a: 'เครื่องมือบีบอัดรูปภาพของเรารองรับรูปแบบทั้งหมดดังนี้:\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
      { q: 'ฉันสามารถบีบอัดหลายรูปพร้อมกันได้หรือไม่?', a: 'ได้แน่นอน คุณสามารถบีบอัดหลายรูปพร้อมกันได้ (แม้มากกว่า 100 รูป) หากอุปกรณ์รองรับ เนื่องจากการบีบอัดใช้ทรัพยากรของเครื่อง อุปกรณ์ที่ประสิทธิภาพสูงจะทำงานได้ลื่นกว่า หากเครื่องสเปกไม่สูง คุณยังสามารถแบ่งบีบอัดเป็นหลายชุดได้ และเครื่องมือนี้ยังคงใช้งานฟรีแม้ทำหลายรอบ.' },
      { q: 'คุณจัดเก็บหรืออัปโหลดรูปภาพของฉันไปยังเซิร์ฟเวอร์หรือไม่?', a: 'ไม่ เราไม่อัปโหลดหรือจัดเก็บรูปภาพของคุณบนเซิร์ฟเวอร์ รูปภาพทั้งหมดถูกบีบอัดแบบภายในเบราว์เซอร์ของคุณเท่านั้น รูปของคุณจะไม่ออกจากอุปกรณ์ จึงเหมาะกับไฟล์ส่วนตัวหรือข้อมูลที่ต้องการความเป็นส่วนตัว.' },
      { q: 'เครื่องมือบีบอัดรูปภาพนี้ใช้ฟรีหรือไม่?', a: 'ใช่ เครื่องมือบีบอัดรูปภาพของเราใช้ฟรีตลอดไป เราจะไม่เรียกเก็บเงินจากคุณ ไม่มีค่าใช้จ่ายแอบแฝง ทุกฟีเจอร์รวมถึงการบีบอัดหลายรูปพร้อมกันใช้งานได้ฟรีทั้งหมด.' },
    ],
    cropImage: [
      { q: 'การครอปรูปภาพจะทำให้คุณภาพลดลงหรือไม่?', a: 'ไม่ การครอปรูปภาพไม่ส่งผลต่อคุณภาพการมองเห็นของรูปเลย การครอปเป็นเพียงการตัดส่วนที่ไม่ต้องการออกเท่านั้น โดยจะไม่เปลี่ยนพิกเซลของส่วนที่คงไว้หลังการครอป ดังนั้นคุณจึงสามารถครอปรูปได้ด้วยคุณภาพต้นฉบับโดยไม่มีความเสียหายของพิกเซล' },
      { q: 'เครื่องมือครอปรูปภาพรองรับไฟล์รูปแบบใดบ้าง?', a: 'คุณสามารถเลือกรูปภาพได้ทุกฟอร์แมต เพราะเครื่องมือครอปรูปภาพของเรารองรับรูปแบบไฟล์แทบทั้งหมด รายการดังนี้:\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
      { q: 'รูปภาพของฉันถูกอัปโหลดไปยังเซิร์ฟเวอร์ของคุณหรือไม่?', a: 'ไม่ การประมวลผลทั้งหมดทำในเบราว์เซอร์บนเครื่องของคุณ รูปภาพของคุณจะไม่ถูกอัปโหลดไปยังเซิร์ฟเวอร์ของเรา เพราะรูปจะไม่ออกจากอุปกรณ์ของคุณ ดังนั้นคุณสามารถครอปรูปส่วนตัวด้วยเครื่องมือของเราได้โดยไม่มีความเสี่ยง' },
      { q: 'ฉันสามารถครอปรูปหลายรูปพร้อมกันได้หรือไม่?', a: 'ได้ คุณสามารถครอปรูปหลายรูปพร้อมกันได้ (แม้มากกว่า 100 รูป) หากระบบของคุณรองรับ เนื่องจากการครอปใช้ทรัพยากรของระบบ หากคุณมีแล็ปท็อป พีซี หรือมือถือประสิทธิภาพสูง คุณสามารถครอปได้หลายรูปพร้อมกัน หากอุปกรณ์ของคุณสเปกไม่สูง คุณสามารถครอปเป็นรอบๆ ได้ เพราะเครื่องมือนี้ฟรีแม้คุณจะครอปหลายรูปพร้อมกัน' },
      { q: 'เครื่องมือครอปรูปภาพนี้ใช้ฟรีหรือไม่?', a: 'ใช่ เครื่องมือครอปรูปภาพนี้ฟรีทั้งหมดตลอดไป คุณสามารถใช้งานได้ทุกที่ ทุกเวลา และบนทุกอุปกรณ์ คุณจะได้รับประสบการณ์แบบ responsive สำหรับทุกอุปกรณ์ และจะไม่มีการเรียกเก็บเงินสำหรับฟีเจอร์พรีเมียมใดๆ ทุกฟีเจอร์ฟรีทั้งหมดโดยไม่มีค่าใช้จ่ายแอบแฝง' },
    ],
    resizeImage: [
      { q: 'ฉันสามารถปรับขนาดหลายรูปพร้อมกันได้ไหม?', a: 'ได้แน่นอน เครื่องมือของเรารองรับการปรับขนาดหลายรูปพร้อมกัน คุณสามารถอัปโหลดรูปได้ตามที่อุปกรณ์รองรับ และเอนจิน AI จะประมวลผลพร้อมกัน หากอุปกรณ์สเปกไม่สูง แนะนำให้ทำเป็นชุดเพื่อลดอาการหน่วง ทั้งหมดทำงานภายในเครื่องโดยไม่อัปโหลดขึ้นเซิร์ฟเวอร์ จึงปลอดภัยต่อความเป็นส่วนตัวของรูปภาพ' },
      { q: 'เครื่องมือปรับขนาดรูปภาพนี้ใช้ฟรีหรือไม่?', a: 'ใช่ เครื่องมือนี้ฟรีถาวร ไม่มีการบังคับสมัครแพ็กเกจแบบชำระเงินเพื่อใช้ฟีเจอร์ขั้นสูง และไม่มีค่าใช้จ่ายแอบแฝงตอนดาวน์โหลดรูปที่ปรับแล้ว' },
      { q: 'การปรับขนาดภาพทำให้คุณภาพลดลงหรือไม่?', a: '✅Decrease Size (downscale): การย่อภาพไม่ทำให้คุณภาพการมองเห็นลดลง โดยหลายกรณีภาพที่ย่อแล้วอาจดูคมขึ้นด้วย ดังนั้นการย่อให้เล็กลงโดยทั่วไปไม่ทำให้คุณภาพเสีย\n❌Increase Size (upscale): การขยายภาพใหญ่กว่าขนาดต้นฉบับอาจกระทบคุณภาพการมองเห็น ยิ่งขยายมาก โอกาสที่คุณภาพจะลดลงยิ่งสูงขึ้น' },
      { q: 'เครื่องมือนี้ปลอดภัยไหม?', a: 'ปลอดภัย เครื่องมือของเราเหมาะกับภาพส่วนตัวหรือภาพที่มีความอ่อนไหว เพราะการประมวลผลทั้งหมดเกิดขึ้นบนอุปกรณ์ของคุณ และไม่มีข้อมูลใดออกจากเครื่อง คุณจึงปรับขนาดภาพได้โดยไม่เสี่ยงด้านความเป็นส่วนตัว' },
      { q: 'รองรับไฟล์ภาพประเภทใดบ้าง?', a: 'เครื่องมือปรับขนาดของเรารองรับทุกฟอร์แมต คุณสามารถเลือกไฟล์ภาพได้ในรูปแบบต่อไปนี้:\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
    ],
    removeBackground: [
      { q: 'การลบพื้นหลังทำงานอย่างไร?', a: 'เราใช้โมเดล AI ขั้นสูงที่ทำงานในเบราว์เซอร์โดยตรงเพื่อตรวจจับวัตถุและแยกออกจากพื้นหลัง' },
      { q: 'ใช้ได้กับพื้นหลังที่ซับซ้อนหรือไม่?', a: 'ได้ โมเดล AI จัดการฉากที่หลากหลาย ผลลัพธ์ที่ดีที่สุดจะได้รับเมื่อมีความต่างที่ชัดเจนระหว่างวัตถุและพื้นหลัง' },
      { q: 'ฉันสามารถลบพื้นหลังจากหลายรูปภาพพร้อมกันได้หรือไม่?', a: 'ได้ อัปโหลดหลายรูปภาพและเครื่องมือจะประมวลผลตามลำดับ' },
      { q: 'รูปแบบไฟล์ผลลัพธ์คืออะไร?', a: 'ผลลัพธ์จะเป็นไฟล์ PNG ที่มีพื้นหลังโปร่งใสเสมอ' },
      { q: 'รูปภาพของฉันถูกส่งไปยังเซิร์ฟเวอร์หรือไม่?', a: 'ไม่ โมเดล AI ทำงานในเบราว์เซอร์โดยใช้ WebAssembly' },
    ],
    watermarkImage: [
      { q: '1. เครื่องมือใส่ลายน้ำของ Photremium ฟรีหรือไม่?', a: 'ใช่ เครื่องมือที่ photremium.com/watermark-image สามารถใช้งานได้ฟรีโดยไม่ต้องมีบัญชีหรือสมัครใช้งาน คุณสามารถใส่ลายน้ำให้ภาพเดี่ยวหรือชุดภาพได้โดยไม่มีข้อจำกัดการดาวน์โหลดหรือการบังคับลงทะเบียน' },
      { q: '2. ฉันสามารถใส่ลายน้ำได้กี่ภาพพร้อมกัน?', a: 'รองรับการใส่ลายน้ำเป็นชุด คุณสามารถลากโฟลเดอร์ภาพทั้งโฟลเดอร์มาวางหรือเลือกหลายไฟล์พร้อมกัน แล้วเครื่องมือจะเรนเดอร์แต่ละภาพตามการตั้งค่าลายน้ำของคุณ' },
      { q: '3. รองรับรูปแบบภาพใดบ้างสำหรับนำเข้าและส่งออก?', a: 'รองรับรูปแบบที่เบราว์เซอร์สามารถอ่านได้ เช่น JPEG, PNG, WEBP, GIF, BMP, SVG โดยผลลัพธ์จะเก็บเป็นฟอร์แมตเดียวกับไฟล์ต้นฉบับ' },
      { q: '4. ลายน้ำจะเหมือนกันบนภาพที่มีความละเอียดต่างกันหรือไม่?', a: 'ใช่ เครื่องมือจะคำนวณตำแหน่งและขนาดแบบสัดส่วนตามภาพอ้างอิง ทำให้ลายน้ำรักษาตำแหน่งและขนาดสัมพัทธ์ข้ามชุดภาพ' },
      { q: '5. ฉันสามารถใช้โลโก้ของตัวเองเป็นลายน้ำได้ไหม?', a: 'ได้ ปุ่ม "Add Image" ช่วยให้คุณอัปโหลดโลโก้ PNG ที่มีพื้นหลังโปร่งใสเพื่อใช้งานเป็นชั้นลายน้ำ ปรับขนาด หมุน และตั้งค่า opacity ได้' },
      { q: '6. จะทำให้ลายน้ำโปร่งหรือกึ่งโปร่งได้อย่างไร?', a: 'เลือกชั้นลายน้ำบนแคนวาสแล้วปรับค่าความทึบในแถบเครื่องมือด้านบน ระดับ 30–50% มักเหมาะสำหรับลายน้ำที่ไม่รบกวนภาพ' },
      { q: '7. สามารถมีลายน้ำหลายชั้นในภาพเดียวได้หรือไม่?', a: 'ได้ ระบบชั้นรองรับหลายชั้น คุณสามารถมีข้อความ โลโก้ และชั้นแบบปูทับพร้อมกัน แต่ละชั้นตั้งค่าแยกกันได้' },
      { q: '8. ฟีเจอร์ tiling คืออะไรและควรใช้เมื่อใด?', a: 'tiling จะทำซ้ำลายน้ำเป็นตารางทั่วทั้งภาพ เหมาะเมื่อคุณต้องการป้องกันการนำภาพไปใช้โดยไม่รับอนุญาต เช่นตัวอย่างสัญญาหรือร่างสำหรับลูกค้า' },
      { q: '9. เครื่องมือนี้รองรับมือถือและแท็บเล็ตหรือไม่?', a: 'รองรับ หน้าจอแคบจะสลับเป็นมุมมองแบบเรียงซ้อน และการควบคุมทั้งหมดรองรับการสัมผัส' },
      { q: '10. ข้อมูลภาพของฉันเป็นส่วนตัวหรือไม่ ภาพจะถูกอัปโหลดไปที่เซิร์ฟเวอร์หรือไม่?', a: 'ภาพของคุณจะไม่ออกจากอุปกรณ์ การประมวลผลทั้งหมดเกิดขึ้นในเบราว์เซอร์โดยใช้ Canvas API และไม่มีการส่งข้อมูลภาพไปยังเซิร์ฟเวอร์' },
    ],
    qrCodeGenerator: [
      { q: 'รหัส QR นี้หมดอายุหรือไม่?', a: 'ไม่ รหัส QR เหล่านี้ไม่มีวันหมดอายุและรับประกันการสนับสนุนตลอดชีวิต เนื่องจากเก็บคำแนะนำที่เข้ารหัสในรูปแบบของบิตภายในกล่องสี่เหลี่ยม ข้อมูลที่เก็บไว้ในนั้นไม่สามารถเปลี่ยนแปลงหรือลบได้ คุณสามารถเข้าถึงข้อมูลในโค้ดได้แค่เพียงสแกนด้วยกล้องใดๆ แม้ว่าจะผ่านไปหลายปีก็ตาม' },
      { q: 'ทำไมรหัส QR ของฉันจึงสแกนไม่ได้?', a: 'รหัส QR ของคุณอาจสแกนไม่ได้เนื่องจากเหตุผลต่อไปนี้: i. ความเป็นcontrast ต่ำ: หากคุณเลือกสีพื้นหลังและสีพื้นหน้าที่คล้ายกัน จะส่งผลต่อการมองเห็นรหัส QR และทำให้การสแกนล้มเหลว แต่เครื่องมือของเรามีคำแนะนำระหว่างการปรับแต่งเกี่ยวกับความเป็นcontrast ต่ำหรือปัญหาที่เกี่ยวข้องกับการสแกนอื่นๆ ii. ข้อมูลขนาดใหญ่: หากคุณสร้างรหัส QR สำหรับข้อความหรือข้อมูลขนาดใหญ่มาก มันจะซับซ้อนและทำให้เกิดปัญหาในการสแกน ตัวตรวจสอบความยาวของข้อความจะให้คำแนะนำเกี่ยวกับความยาวของข้อความที่เหมาะสมที่สุดในระหว่างการสร้างรหัส QR iii. การพิมพ์คลุมเครือ: ตรวจสอบให้แน่ใจว่าดาวน์โหลดรหัส QR ของคุณในรูปแบบความละเอียดสูงเช่น PNG หรือ SVG ซึ่งเครื่องมือของเรารองรับแล้ว' },
      { q: 'ฉันสามารถเพิ่มโลโก้ในรหัส QR ได้หรือไม่?', a: 'แน่นอนว่าได้ คุณสามารถเพิ่มโลโก้ที่กำหนดเองหรือเลือกหนึ่งจากไลบรารี่โลโก้ในตัวสำหรับรหัส QR ของคุณ โลโก้ที่คุณเลือกจะได้รับการปรับแต่งโดยอัตโนมัติทั่วที่กลางของรหัส QR' },
      { q: 'ฉันจะสแกนรหัส QR ได้อย่างไร?', a: 'คุณสามารถสแกนรหัส QR โดยใช้กล้องมือถือ แต่สำหรับการเปลี่ยนเส้นทางอัตโนมัติไปยังลิงก์และคุณสมบัติขั้นสูงอื่นๆ อีกมากมาย คุณสามารถไปที่เครื่องสแกนรหัส QR ของเราได้ฟรีโดยใช้ลิงก์ https://photremium.com/qr-code-scanner' },
      { q: 'ฉันสามารถสร้างรหัส QR ฟรีได้กี่อัน?', a: 'ไม่มีจำกัด! คุณสามารถสร้างรหัส QR หลายตัวได้ฟรี ฟีเจอร์ การปรับแต่ง และเทมเพลตทั้งหมดฟรีตลอดไปสำหรับทุกคน ไม่ต้องเสียค่าสมาชิกเพื่อเพลิดเพลินกับฟีเจอร์พรีเมียม' },
      { q: 'ฉันต้องเข้าสู่ระบบ/ลงทะเบียนเพื่อสร้างรหัส QR หรือไม่?', a: 'ไม่ เพียงแค่ป้อนข้อความของคุณ สร้างรหัส QR และดาวน์โหลดหลังจากปรับแต่ง ไม่จำเป็นต้องเข้าสู่ระบบหรือลงทะเบียนเนื่องจากสามารถเข้าถึงฟีเจอร์ทั้งหมดได้ฟรีอย่างสมบูรณ์' },
    ],
    qrCodeScanner: [
      { q: 'ฉันสามารถสแกนคิวอาร์โค้ดจากรูปภาพที่บันทึกไว้และภาพหน้าจอได้ไหม?', a: '**ใช่**, คุณสามารถสแกนคิวอาร์โค้ดจากรูปภาพที่บันทึกไว้หรือภาพหน้าจอได้ เครื่องสแกนคิวอาร์โค้ดของเรา https://photremium.com/qr-code-scanner ให้คุณสแกนคิวอาร์โค้ดจากแกลเลอรีได้ คุณเพียงเลือกภาพ แล้วจะได้รับข้อมูลทั้งหมดที่ถอดรหัสจากคิวอาร์โค้ดนั้น' },
      { q: 'ฉันต้องติดตั้งแอปเพื่อใช้เครื่องสแกนคิวอาร์โค้ดไหม?', a: '**ไม่**, เครื่องสแกนคิวอาร์โค้ดแบบเว็บของเราช่วยให้คุณสแกนคิวอาร์โค้ดได้โดยไม่ต้องติดตั้งแอปใด ๆ คุณสามารถใช้งานเครื่องสแกนคิวอาร์โค้ดขั้นสูงของเราได้ฟรีบนทุกอุปกรณ์' },
      { q: 'ทำไมสแกนเนอร์ไม่รู้จักคิวอาร์โค้ด?', a: 'คิวอาร์โค้ดของคุณไม่ถูกสแกนเนื่องจากสาเหตุใดสาเหตุหนึ่งต่อไปนี้: i. แสงไม่เพียงพอ: การสแกนคิวอาร์โค้ดในที่แสงน้อยอาจทำให้สแกนยาก เปิดไฟฉายและเพิ่มความสว่างหากคุณสแกนจากหน้าจอใด ๆ ii. ระยะห่าง: การสแกนคิวอาร์โค้ดจากระยะที่ไม่เหมาะสมก็ทำให้เกิดปัญหาได้เช่นกัน ระยะที่เหมาะสมในการสแกนคิวอาร์โค้ดคือประมาณ 10 นิ้ว (25cm) iii. เลนส์กล้องสกปรก: คิวอาร์โค้ดอาจสแกนไม่ผ่านเพราะเลนส์สกปรก ทำความสะอาดเลนส์ก่อนสแกน “คุณเห็นกรอบตารางในสแกนเนอร์ไหม? เพียงจัดคิวอาร์โค้ดให้อยู่ในกรอบนั้นก็สแกนได้สำเร็จ”' },
      { q: 'เครื่องมือนี้สแกนคิวอาร์โค้ดแบบกลับสีหรือแบบมีสีได้ไหม?', a: '**ใช่**, คุณสามารถสแกน QR ได้ทุกสีหรือทุกทิศทาง อย่างไรก็ตาม หากความต่างสีระหว่างพื้นหลังกับพื้นหน้าต่ำ อาจทำให้สแกนได้ยาก' },
      { q: 'เครื่องมือนี้ใช้ฟรีไหม?', a: '**ใช่**, เครื่องมือนี้ใช้ฟรีทั้งหมด คุณสามารถสแกนคิวอาร์โค้ดได้ไม่จำกัดฟรีตลอดไป' },
    ],
    faceBlur: [
      { q: 'การตรวจจับใบหน้าทำงานอย่างไร?', a: 'โมเดลตรวจจับใบหน้าที่ขับเคลื่อนด้วย AI ทำงานในเบราว์เซอร์ของคุณโดยตรง มันระบุใบหน้าในรูปภาพ' },
      { q: 'ฉันสามารถเลือกใบหน้าที่จะเบลอได้หรือไม่?', a: 'ได้ หลังจากตรวจจับแล้ว บริเวณใบหน้าแต่ละส่วนจะถูกไฮไลต์และคุณสามารถเลือกใบหน้าที่ต้องการเบลอ' },
      { q: 'มีสไตล์การเบลอใดบ้าง?', a: 'คุณสามารถเลือก Gaussian blur, pixelation หรือ solid color overlay และปรับความเข้ม' },
      { q: 'ฉันสามารถเบลอใบหน้าในหลายรูปภาพพร้อมกันได้หรือไม่?', a: 'ได้ อัปโหลดหลายรูปภาพ กำหนดค่าบริเวณเบลอ แล้วดาวน์โหลดรูปภาพที่ประมวลผลแล้วทั้งหมด' },
      { q: 'รูปภาพของฉันถูกส่งไปยังเซิร์ฟเวอร์ระยะไกลหรือไม่?', a: 'ไม่ โมเดล AI ทำงานในเบราว์เซอร์โดยใช้ WebAssembly' },
    ],
    photoEditor: [
      { q: 'มีฟีเจอร์การแก้ไขใดบ้าง?', a: 'ปรับความสว่าง ความคมชัด ความอิ่มตัว ใช้ฟิลเตอร์ เพิ่มข้อความ โอเวอร์เลย์ กรอบ และสติกเกอร์ — ทั้งหมดในเบราว์เซอร์' },
      { q: 'ฉันสามารถเลิกทำและทำซ้ำการเปลี่ยนแปลงได้หรือไม่?', a: 'ได้ ตัวแก้ไขรองรับประวัติการเลิกทำ/ทำซ้ำอย่างสมบูรณ์' },
      { q: 'รูปแบบไฟล์ใดบ้างที่สามารถแก้ไขและส่งออกได้?', a: 'คุณสามารถแก้ไข JPG, PNG, WEBP และรูปแบบยอดนิยมอื่นๆ' },
      { q: 'ตัวแก้ไขทำงานบนโทรศัพท์หรือไม่?', a: 'ได้ ตัวแก้ไขตอบสนองอย่างสมบูรณ์และเป็นมิตรกับหน้าจอสัมผัส' },
      { q: 'รูปภาพของฉันถูกจัดเก็บบนเซิร์ฟเวอร์หรือไม่?', a: 'ไม่ การแก้ไขทั้งหมดเกิดขึ้นในเครื่อง' },
    ],
  },
};

export default th;